import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { localStorageGet } from "./utils/LocalStorageHelper";

const defaultLanguage = localStorageGet("i18nextLng");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "de"],
    lng: defaultLanguage || "en",
    fallbackLng: "de",
    react: {
      useSuspense: false,
    },
    resources: {
      en: {
        translation: {
          // MAIN PAGE
          en: "EN",
          de: "DE",
          SignIn: "Sign In",
          RequestDemo: "Request a Demo",
          TransformYour: "Transform your",
          Monitor: "Monitor",
          Operations: "Operations",
          YouKnow: "You know your process best",
          Predict: "Unlock",
          TopErrors: "AI Insights",
          WeHandle: "We turn data into actions",
          Stop: "Boost",
          UnplannedDowntime: "Efficiency",
          YouFocus: "Focus on results and cost reduction",
          ManufacturingWithAI: "manufacturing with AI",
          EndToEndSaaS:
            "A no-code, self-service B2B SaaS analytics platform that helps manufacturing experts, operations managers, and B2B teams harness AI and transform operational data into efficiency gains and cost reductions - without data-science expertise. GDPR compliant with enterprise-grade data privacy. Perfect for automotive manufacturing, OEM operations, financial analytics, and sales analytics.",
          LandingPageDesc:
            "Predsense develops an advanced no-code analytics platform that transforms manufacturing and operational data into actionable insights using AI-powered analysis. Our B2B SaaS solution helps automotive manufacturing, OEM, and enterprise teams implement data-driven improvements, financial analytics, and anomaly detection - all with GDPR compliance and without requiring data science expertise. Ideal for operations managers seeking time series analytics and interactive time series visualization.",
          PredictAndPrevent:
            "Predict and prevent machine failures before they occur",
          PredsenseIsAIPlatform:
            "The focus is on identifying, quantifying, and reducing operational inefficiencies through advanced analytics and anomaly detection. The goal: to reduce operational costs by up to 20% and improve overall process efficiency across various industries.",

          DecreaseInMachineDowntime: "Decrease in machine downtime",
          IncreaseInProductivity: "Increase in productivity",
          GenerateComprehensiveReports:
            "Generate comprehensive reports with actionable insights. Our solution provides detailed analysis of machine performance, maintenance history, and predicted maintenance needs, helping you make data-driven decisions.",

          WhyPredsense: "Why Predsense",
          TransformingIndustrial:
            "Transforming industrial maintenance with AI-Powered predictive analytics",
          Vision: "Why Predsense",
          Mission: "Mission",
          Impact: "Impact",
          VisionShort:
            "Our vision is to transform the manufacturing industry with human-centric AI tools",
          MissionShort:
            "Our mission is to enable broad access to AI in the manufacturing industry by delivering intuitive and scalable AI tools that drive innovation, efficiency and competitive advantage",
          ImpactShort:
            "Our AI-powered solution has already helped numerous companies achieve significant improvements in their maintenance operations",

          RealTimeMonitoring: "Offline Analysis",
          AutomatedFaultDetection: "Time Series Anomaly Detection",
          AutomatedFaultDetectionDesc:
            "Our anomaly detection tool automatically detects anomalies in time series, performs multivariate anomaly detection, groups them into common failure patterns, and provides interactive time series visualization. Built for seamless integration with your existing systems via APIs.",
          SmartAnalytics: "Data-Driven Decisions",
          BusinessIntelligenceReport:
            "Business Intelligence Report with Forecasting Analytics",
          BusinessIntelligenceReportDesc:
            "Turn raw time series data into measurable value with actionable insights and predictive analytics. Our forecasting software delivers diagnostic reports with KPIs, failure analysis, and asset-specific cost savings. The generated report includes time series analysis and anomaly detection insights that empower data-driven decisions to reduce unplanned downtime and drive predictive maintenance at scale. The tool can be used across industries with time series analytics e.g. operations, financial analytics, and marketing or sales analytics.",
          FirstInsights: "First Insights",

          ReductionInMaintenance: "Reduction in maintenance costs",
          DecreaseInDowntime: "Decrease in machine downtime",

          OurJourney: "Our Journey",
          FromBreakthroughToGlobalImpact: "From small steps to global impact",
          ProofOfConcept: "Proof of Concept & Partnerships",
          MarketEntry: "Market Entry & Recognition",
          GlobalImpact: "Global Impact",

          MeetOurTeam: "Meet Our Team",
          BuildingFuture: "Building the Future of",
          IndustrialAI: "Industrial AI",
          AIAndManufacturingExpert: "AI & Manufacturing Expert",
          SoftwareEngineer: "Software Engineer",

          Contact: "Contact",
          Us: "Us",
          ReadyToTransform: "Build predictive AI within minutes - not months.",
          GetInTouch: "Get in Touch",
          SendMessage: "Send Message",

          PrivacyPolicy: "Privacy Policy",
          TermsOfService: "Terms of Service",
          And: "and",

          MachineLearningModels: "Machine Learning Models",
          EarlyWarningBeforeFailure: "Early warning before failure",
          ReductionInUnplannedDowntime: "Reduction in unplanned downtime",
          DecreaseInMaintenanceCosts: "Decrease in maintenance costs",

          PredsenseTitle:
            "AI-Powered Analytics Platform for Time Series Data | Predsense",
          TransformMaintenanceOps:
            "Transform your maintenance operations with our AI-powered predictive maintenance solution",
          AIAlgorithmsMonitor:
            "Our AI algorithms continuously monitor your machine data in real-time, detecting anomalies and potential failures before they occur. This proactive approach helps you prevent costly downtime and optimize maintenance schedules.",
          YourManufacturing: "Your Manufacturing",
          Empower: "Empower",
          OurSolution: "Our Solution",
          AutomaticDataAnalysis: "Automatic Data Analysis",
          SelfServiceAnalytics: " Self-Service Analytics Platform",
          AnalyticsAndInsights: "Analytik und Erkenntnisse",
          AnalyticsAndInsightsDesc:
            "Benutzerdefinierte Datenanalytik, KPI-Frameworks und BI-Dashboards",

          WithOver: "With",
          Years: "years",
          InPharmaceutical:
            "in pharmaceutical manufacturing, Dalibor managed GxP production plants as an ",
          SucLed: "and successfully led 40+ projects as a ",
          ProjectManager:
            "He developed the core AI engine powering our tool and drives our mission with his deep expertise in",
          DuringStudies: "and",

          AversatileEngineer: "A versatile",
          JavaPythonExpert: "Backend & DevOps Engineer",
          WithExperience:
            "with 7+ years of experience in B2B SaaS solutions across various industries. Specializes in",
          Cybersecurity: "Cybersecurity, DevOps",
          AndComputerVision: "& Machine Learning",
          LeadsDevelopment:
            "He leads the development of our core AI engine and backend infrastructure, ensuring our solution scales seamlessly across all customer production machines.",

          A: "A",
          FrontendDeveloper: "Frontend Developer",
          MilanExperience:
            "with 7+ years of experience building B2B SaaS solutions and ERP systems across industries, Milan specializes in ",
          UIDevelopment: "UI Development",
          ERPConsulting: "Design",
          MilanSupport:
            "He drives the UI Development of our no-code solution to ensure broad adoption - empowering users without AI expertise.",

          ProofOfConceptDescription:
            "Successfully validated with 19 real industrial datasets. Established 5 key partnerships to expand our network across the DACH manufacturing industry.",
          MarketEntryDescription:
            "After successfully launching our Beta Version in Q1 2025, we are collaborating with early adopters to generate measurable success stories.",
          GlobalImpactDescription:
            "Expanding beyond DACH to deliver Predictive Maintenance to EVERY SME manufacturer and democratize AI across industries.",

          ScheduleDemo:
            "Schedule a demo or reach out to learn how Predsense can help optimize your operations.",
          Location: "Wörgl, Austria",
          Required: "Required",
          FullName: "Full Name",
          CompanyName: "Company Name",
          IAgreeToPredsense: "I agree to Predsense's",
          PrivacyAndTerms: "Privacy Policy",
          EmailSuccessfullySent: "Email successfully sent",

          GenerateComprehensiveReportsWithInsights:
            "Generate comprehensive reports with actionable insights. Our solution provides detailed analysis of machine performance, maintenance history, and predicted maintenance needs, helping you make data-driven decisions.",

          OurPartnersTitle: "Our",
          PartnersSpan: "Partners",

          // SEO Optimized Content - Home Page
          HeroSEOText:
            "Transform your manufacturing operations with our B2B SaaS platform. Our no-code analytics solution helps manufacturing companies optimize sales, improve financial analytics, and ensure GDPR compliance. Perfect for automotive manufacturing, OEM operations, and enterprise teams seeking data-driven insights.",
          ProductsShowcaseSEO:
            "Discover our comprehensive solutions for time series analytics, data annotation, and anomaly detection. Our platform supports B2B and B2C users with advanced API integration, enabling seamless data analysis for manufacturing, finance, and sales teams.",
          PartnersSEOText:
            "We partner with leading technology providers and innovation hubs to deliver enterprise-grade analytics solutions. Our partnerships enable seamless integration with existing B2B systems, ensuring GDPR compliance and data privacy for manufacturing and financial analytics.",
          FAQSEOHeading:
            "Frequently Asked Questions About B2B Analytics and Manufacturing Solutions",
          FAQSEOText:
            "Learn more about our no-code analytics platform, data annotation tools, API integration, and how our solutions help manufacturing companies, B2B teams, and enterprise organizations optimize operations, improve sales analytics, and ensure GDPR compliance. Our platform supports automotive manufacturing, OEM operations, financial analytics, and more.",
          TimeSeriesLabelingSEO:
            "Our data annotation platform supports dataset annotation, data notation, and machine learning workflows. Perfect for time series annotation, automated labeling, and preparing data for AI models. Ideal for B2B and B2C users seeking efficient data annotation tools.",
          AnomalyDetectionSEO:
            "Advanced API platform for time series anomaly detection. Our anomaly detection software integrates seamlessly via API gateway, supporting FastAPI and REST API architectures. Perfect for B2B enterprise solutions requiring real-time anomaly detection and forecasting analytics.",
          AnomalyDetectionSEOHeading:
            "Enterprise API Platform for Time Series Anomaly Detection",
          AnomalyDetectionSEOText:
            "Our API platform provides comprehensive anomaly detection capabilities through REST API and API gateway integration. Built with FastAPI for optimal performance, our API solution enables seamless integration with existing systems. Perfect for developers, API developers, and B2B teams requiring robust API management and anomaly detection APIs. Support for real-time streaming, batch processing, and custom API endpoints makes our platform ideal for enterprise deployments.",

          EnterYourFullName: "Enter your full name",
          EnterYourCompanyName: "Enter your company name",
          EnterYourEmail: "Enter your business email address",
          EnterYourPhoneNumber: "Enter your phone number",
          TellUsAboutYourNeeds: "Tell us about your needs and how we can help",

          FromBreakthroughInnovation:
            "From Breakthrough Innovation to Global Impact",
          MarketEntryAndRecognition: "Market Entry & Recognition",

          Email: "Email Address",
          Phone: "Phone Number",
          Message: "Message",

          // SignUp translations
          CreateFreeAccount: "Create a free account",
          AlreadyHaveAccount: "Already have an account?",
          SignInHere: "Sign in here",
          EmailAddress: "Business Email",
          EnterWorkEmail: "Enter your work email",
          FirstName: "First name",
          LastName: "Last name",
          EnterFirstName: "Enter first name",
          EnterLastName: "Enter last name",
          PhoneNumber: "Phone number",
          EnterPhoneNumber: "Enter phone number",
          WhatWillYouUse: "How will you use Predsense?",
          BusinessUse: "Business use",
          Other: "Other",
          EnterCompanyName: "Enter company name",
          JobFunction: "Job function",
          EnterJobFunction: "Enter job function",
          Country: "Country",
          SelectCountry: "Select your country",
          IAgreeToThe: "I agree to the",
          EndUserLicense: "Terms & Conditions",
          AndThe: "and the",
          GetPredsenseTrial: "Start my free 14-day trial",
          PredictiveMaintenance:
            "Unplanned downtime costs up to €150 000 per hour.",
          FixThat: "Measure your actual savings.",
          ReduceMaintenance:
            "Get actionable insights in 24h - zero AI skills needed.",
          PreventMachine:
            "Predict failures on any production machines in real-time.",
          StartImplementing:
            "Slash production costs by 20% with data-driven optimizations.",

          // Form messages
          ThankYouForRegistering:
            "Thank you for registering! We will contact you soon.",
          ErrorSendingForm: "Error sending form. Please try again.",

          // Footer translations
          Impressum: "Legal Notice",
          Datenschutz: "Privacy Policy",
          LlmInfoLink: "LLM info",

          // LLM / AEO info page (/llm-info)
          LlmInfoPageTitle: "LLM info - Predsense | Facts for AI systems",
          LlmInfoMetaDescription:
            "Canonical, factual summary of Predsense (PredSense GmbH): predictive AI for manufacturing, SaaS platform, consulting, onboarding, legal entity, URLs, and topics for AI assistants and answer engines.",
          LlmInfoH1: "Machine-readable summary (LLM info)",
          LlmInfoLead:
            "This page states verifiable facts about Predsense in plain language so assistants, search, and retrieval systems can cite accurate information. It complements the marketing site and legal pages.",
          LlmInfoSectionAnswerTitle: "What is Predsense?",
          LlmInfoSectionAnswerP1:
            "Predsense is an Austrian AI startup headquartered in Tyrol, specializing in Predictive AI for manufacturing environments. Predsense is the public brand of PredSense GmbH.",
          LlmInfoSectionAnswerP2:
            "The company operates two independent business lines: a self-service SaaS platform for anomaly detection and time series labeling, and data-driven consulting and IT services for production companies across the DACH region and Italy.",
          LlmInfoSectionProductTitle: "What does the Predsense product do?",
          LlmInfoSectionProductBody:
            "The Predsense platform is the intelligence layer for production managers: it translates process knowledge from domain experts into scalable Predictive AI models and predicts downtime before it happens - in minutes, not months, without data scientists and without code. The platform integrates as an add-on to existing systems such as data historians or MES; it does not replace them. Core features include automatic anomaly detection in sensor data, self-service time series labeling, root-cause analysis, and automated BI reports with ROI calculations. Target users are production managers and operations teams in the pharmaceutical and food & beverage manufacturing industries worldwide.",
          LlmInfoSectionServicesOfferingTitle: "What are the Predsense services?",
          LlmInfoSectionServicesOfferingBody:
            "Predsense helps manufacturing companies unlock hidden optimization potential through data-driven consulting and tailored IT solutions. Services include data integration, analytics and business intelligence, process automation, and AI consulting. The services division targets operations decision-makers in Germany, Austria, Switzerland, and Italy. A key differentiator is the combination of 30+ years of industry experience in production and enterprise software with modern AI expertise.",
          LlmInfoSectionOnboardingTitle: "How does onboarding with Predsense work?",
          LlmInfoSectionOnboardingBody:
            "Predsense follows a milestone-based approach: engagement begins with a free one-hour consultation, followed by a paid use case evaluation based on customer data with a quantified savings report, and concludes with a concrete implementation proposal. Clients can exit after each milestone - no long-term commitment before proven value.",
          LlmInfoSectionProblemTitle: "What problem does Predsense solve?",
          LlmInfoSectionProblemBody:
            "Unplanned machine downtime can cost manufacturing SMEs up to €150,000 per hour. Many production teams lack the AI expertise and tools to detect failures early. Predsense enables production managers to build and deploy Predictive AI models using their own domain knowledge - independently, without external data specialists and without coding skills.",
          LlmInfoSectionAudienceTitle: "Who is Predsense for?",
          LlmInfoSectionAudienceBody:
            "The Predsense product targets production managers, process engineers, and operations teams in manufacturing globally - with a particular focus on the pharmaceutical and food & beverage industries. Consulting services are primarily aimed at mid-sized manufacturing companies in the DACH region and Italy.",
          LlmInfoSectionEntityTitle: "Legal entity and contact",
          LlmInfoFactLegalName: "Legal name:",
          LlmInfoFactLegalNameValue: "PredSense GmbH",
          LlmInfoFactBrand: "Brand / product name:",
          LlmInfoFactBrandValue: "Predsense",
          LlmInfoFactAddress: "Address:",
          LlmInfoFactAddressValue: "Ladestraße 2, 6300 Wörgl",
          LlmInfoFactCountry: "Country:",
          LlmInfoFactCountryValue: "Austria",
          LlmInfoFactEmail: "Email:",
          LlmInfoFactPhone: "Phone:",
          LlmInfoFactWebsite: "Official website:",
          LlmInfoFactLinkedIn: "LinkedIn company page:",
          LlmInfoSectionProductsTitle: "Products and entry points",
          LlmInfoSectionProductsIntro:
            "Use these URLs as stable references when describing what Predsense offers:",
          LlmInfoProductLabeling:
            "Data labeling and annotation workflows for time-series and operational datasets.",
          LlmInfoProductAnomaly:
            "Time series anomaly detection, multivariate analysis, and related analytics features.",
          LlmInfoProductPricing: "Plans and commercial information.",
          LlmInfoProductServices:
            "Consulting and IT services for manufacturing (data integration, analytics, automation, AI consulting).",
          LlmInfoProductApp: "Customer web application (login).",
          LlmInfoSectionTopicsTitle: "Topics Predsense is associated with",
          LlmInfoSectionTopicsIntro:
            "For topical disambiguation (not an exhaustive keyword list):",
          LlmInfoTopic1:
            "Predictive maintenance and predictive analytics for manufacturing; downtime prediction and operational decision support",
          LlmInfoTopic2:
            "Unplanned downtime cost, OEE, manufacturing KPIs, and predictive maintenance ROI",
          LlmInfoTopic3:
            "Root cause analysis vs predictive analytics; operational transparency before AI strategy",
          LlmInfoTopic4:
            "Self-service anomaly detection, time series labeling, and MES/PLC/SCADA/historian integration",
          LlmInfoTopic5:
            "Data-driven consulting: integration, analytics, automation, AI consulting (DACH and Italy)",
          LlmInfoTopic6:
            "B2B SaaS, no-code analytics, GDPR-oriented data handling for European manufacturing teams",
          LlmInfoSectionCiteTitle: "Preferred citations",
          LlmInfoSectionCiteBody:
            "When summarizing Predsense, prefer linking to the homepage, the about page, or this LLM info page so facts stay aligned with official sources.",

          // Header translations
          StartFree: "Start Free",
          Product: "Solution",
          Team: "About Us",

          // CSV Format section
          DataFormat: "Data Format",
          UploadYourData: "Upload Your Data",
          CSVFormatDescription:
            "Simply upload your machine data in CSV format. We support various time-series data including temperature, pressure, vibration, and other sensor readings. Our system automatically processes and analyzes your data.",
          SupportedFormat: "Supported format",
          TimeSeriesData: "Time-series data",
          EasyIntegration: "Easy integration",

          // Awards section
          FirstPlace: "1st Place",
          Fit4BusinessAwardDescription:
            "FIT4BUSINESS is a business idea competition organized by FH Kufstein Tirol, Innovationsraum Kufstein and STARTUP.TIROL. An expert jury evaluates business ideas, awarding the most promising business concepts and innovative projects with high implementation potential.",
          December: "December",

          Awards: "Awards",
          AndRecognitions: "& Recognitions",

          // Vision section
          InitialAnalysis: "Initial Analysis",
          SystematicImplementation: "Systematic Implementation",
          SystematicImplementationDesc:
            "Users filter anomalies and provide diagnostic context to define use cases, enabling the AI engine to auto-train optimal condition monitoring models.",
          AchieveScalableSavings: "Achieve Scalable Savings",
          AchieveScalableSavingsDesc:
            "Users deploy individual models per machine, enabling scalable, real-time error prediction across entire production lines.",
          InitialAnalysisDesc:
            "Automatically checks data quality, prepares it for machine learning, and performs anomaly detection upon uploading a sensor dataset as a .csv file.",
          DataDrivenDecisions: "Data-Driven Decisions",
          DataDrivenDecisionsPDF: "PDF Report for Data-Driven Decisions",
          ConditionMonitoring: "Condition Monitoring",
          FaultDiagnosis: "Fault – Diagnosis",
          RealTimeErrorPrediction: "Real-Time Error Prediction",

          MaintenanceCostsReduction: "20%",
          MaintenanceCostsLabel: "Savings in Production Costs",
          MachineDowntimeDecrease: "18%",
          MachineDowntimeLabel: "Decrease in machine downtime",
          ProductivityIncrease: "10%",
          ProductivityLabel: "Higher Efficiency in Production",
          InitialAnalysisDays: "< 24h",
          Hours: "Hours",

          EmailError: "Failed to send email. Please try again.",
          InvalidEmail: "Please enter a valid email address",

          // Impressum / Legal Notice
          LegalNotice: "Legal Notice",
          BusinessPurpose: "Business purpose",
          VATNumber: "VAT number",
          CompanyRegisterNumber: "Company register number (FN)",
          CommercialCourt: "Commercial court",
          RegisteredOffice: "Registered office",
          ChamberOfCommerce: "Membership in the Chamber of Commerce",
          LegalRegulations: "Legal regulations",
          SupervisoryAuthority: "Supervisory authority / Trade authority",
          OnlineDispute: "Information on online dispute resolution",
          MediaOwner: "Media owner",
          MediaOwnerPurpose: "Business purpose of the media owner",
          EditorialDirection:
            "Basic editorial direction of the website and our newsletters:",
          Presentation: "Presentation of PredSense GmbH",
          ProductInfo: "Information about the offered products and services",
          ContactForm: "Contact form",
          Austria: "Austria",
          Germany: "Germany",
          InitialQuestionsDispute:
            "For initial questions about a possible dispute resolution, please contact us at",

          // Cookie Banner
          CookieTitle: "Our website uses cookies",
          CookiePreferences: "Preferences",
          WeUseCookies:
            "We use cookies to improve your experience, analyze traffic, and personalize content. You can manage your preferences or accept/reject all cookies below. Learn more in our",
          AcceptAll: "Accept All",
          RejectAll: "Reject All",
          SavePreferences: "Save Preferences",
          Necessary: "Necessary",
          Functional: "Functional",
          Analytics: "Analytics",
          Performance: "Performance",
          EssentialCookiesDesc:
            "Essential cookies enable core functionality such as security, network management, and accessibility. These cookies are always active and cannot be disabled.",
          FunctionalCookiesDesc:
            "Functional cookies allow the website to remember user choices and provide enhanced, more personalized features. If you disable these, some parts of the site may not function properly.",
          AnalyticsCookiesDesc:
            "Analytics cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. We use tools such as Google Analytics to improve our services. These cookies will only be set if you accept them.",
          PerformanceCookiesDesc: "Help us improve website performance",

          // Form Popup
          WelcomePopup: "Quick Survey 📊",
          PopupMessage1:
            "We're running a quick survey to improve our services.",
          PopupMessage2: "Do you have 5 minutes to help us?",
          FillForm: "Take survey",
          MaybeLater: "Maybe later",

          // Consulting Services
          ConsultingServices: "Services",
          ConsultingServicesDesc:
            "With a combined 30 years of experience in software development, pharmaceutical manufacturing, engineering, and management, Predsense offers AI consulting, AI management consulting, project management AI, AI workshops for managers, and AI for risk management alongside customized IT solutions.",
          ProjectManagement: "Project Management",
          ProjectManagementDesc:
            "Process Improvement Methodologies, Process Mapping and Custom Project Management Services",
          CustomizedIT: "Customized Solutions",
          Workshops:
            "Workshops for Digital Transformation and Customized IT Solutions",
          ContactForConsulting: "Contact us for consulting services",
          ContactUs: "Contact Us",
          GetConsultingQuote: "Contact Us",

          // Soon Features
          SoonNewFeatures: "New Features Coming Soon",
          SoonFeaturesDesc:
            "We're constantly working on new features to enhance your analytics experience. Stay tuned for exciting updates!",
          ComingSoon: "Coming Soon",
          JoinWaitlist: "Contact us",

          // Products & Labeling
          Products: "Products",
          Labeling: "Labeling",
          LabelingPageTitle:
            "AI Data Labeling Tool for Time Series | Predsense",
          LabelingAppTitle: "Data Annotation & Labeling Platform",
          LabelingAppDescription:
            "An intuitive data annotation tool and AI-powered data labeling platform that empowers you to efficiently annotate, organize, and analyze your time-series data. Our data annotation software supports automated annotation, AI annotation tools, dataset annotation, data notation, and machine learning annotation workflows. Perfect for time series annotation, data annotation for AI, and preparing labeled datasets for machine learning models. Create events, define rules, and leverage AI-powered chat assistance to transform raw sensor data into actionable insights.",
          LabelingSEOHeading:
            "Advanced Data Annotation and Dataset Labeling Platform",
          LabelingSEOText:
            "Our data annotation platform provides comprehensive tools for dataset annotation, data notation, and time series annotation. Whether you need AI annotation tools, automated data labeling, or manual annotation workflows, our platform supports all data annotation use cases. Perfect for machine learning data preparation, AI model training, and creating high-quality labeled datasets. Support for CSV import/export, collaborative annotation, and AI-assisted labeling makes our platform ideal for B2B and B2C users.",

          // Labeling Features
          DataImport: "Data Import",
          EventLabeling: "Event Labeling",
          AutomatedLabeling: "Automated Labeling",
          AIAssistant: "AI Assistant",
          Reporting: "Reporting",
          DataExport: "Data Export",

          LabelingUploadTitle: "Upload Your Data for Annotation",
          LabelingUploadDesc:
            "Easily upload your CSV/Excel files containing time-series sensor data to our data annotation tool. Our annotation tool automatically validates the data format and prepares it for data labeling and analysis. Perfect for time series annotation and data notation workflows as part of machine learning data preparation.",

          LabelingCreateEventTitle: "Manual Data Annotation & Event Labeling",
          LabelingCreateEventDesc:
            "Manually create and annotate events directly through our interactive chart. Simply select the time range and define event properties. Perfect for precise data annotation of specific incidents, anomalies, or operational states in your production data.",

          LabelingRulesTitle: "Automated Data Annotation with Rules",
          LabelingRulesDesc:
            "Define custom rules for automated data labeling and annotation. Our AI annotation tool automatically detects and creates events based on static rules. Set thresholds, conditions, and triggers that match your operational requirements. Once configured, automated annotation rules can instantly generate multiple labeled events across your entire dataset. Perfect for dataset annotation and time series annotation automation.",

          LabelingChatEventsTitle: "AI supported Event Detection",
          LabelingChatEventsDesc:
            "Use our chat to describe what you're looking for in plain text, and our AI agent will automatically detect and highlight matching events on your charts. Our AI agent translates text into queries with customized code to identify patterns. Simply ask questions like 'Find all temperature spikes above 80°C' and watch the AI Agent identify them instantly. Advanced AI annotation for time series annotation workflows.",

          LabelingChatAverageTitle: "Calculate Statistical Insights",
          LabelingChatAverageDesc:
            "Ask the AI assistant to calculate e.g. average values for any time period and column. Get instant statistical insights without manual calculations. Perfect for comparing performance across different time ranges or identifying baseline values.",

          LabelingChatSimilarTitle: "Find Similar Patterns",
          LabelingChatSimilarDesc:
            "Discover correlations and similar patterns between different sensors or data streams. The AI agent analyzes relationships in your data and highlights matching patterns, helping you identify connections and dependencies in your processes.",

          LabelingChatYesterdayTitle: "Compare Historical Data",
          LabelingChatYesterdayDesc:
            "Quickly compare current data with yesterday's values or any historical period. The AI assistant overlays historical data on your charts, making it easy to spot trends, anomalies, or changes in your processes over time.",

          LabelingPdfReportTitle: "Generate PDF Reports",
          LabelingPdfReportDesc:
            "Export comprehensive PDF reports containing your labeled data, charts, events with context. Reports include all annotations, rules, and insights in a professional format ready for sharing with management for fast data driven decision making.",

          LabelingExportDataTitle: "Export Annotated Data for Machine Learning",
          LabelingExportDataDesc:
            "Export your labeled dataset with all events and annotations as CSV files. The exported data includes original sensor readings plus additional columns for event labels, timestamps, and metadata. Perfect for training machine learning models or further analysis.",
          Collaboration: "Collaboration",
          StartFreeTrial: "Start Free Trial",
          ViewPricing: "View Pricing",

          // Home Page SEO
          HomePageTitle:
            "Predsense | AI-Powered Time Series Analytics",
          HomePageDescription:
            "Transform your operations with predictive analytics and AI-powered insights. Perfect for individuals, teams, enterprises seeking data-driven decisions on scale.",
          HomePageKeywords:
            "time series analytics, anomaly detection, time series data, predictive analytics, no-code analytics, B2B analytics, manufacturing analytics, time series visualization, AI analytics, data annotation, B2B SaaS, manufacturing companies, financial analytics, sales analytics, GDPR compliance, automotive manufacturing, OEM, API platform, data privacy",

          // Pricing Page
          PricingPageTitle: "Pricing Plans - Time Series Analytics | Predsense",
          PricingPageDescription:
            "Choose the right pricing plan for your time series analytics and anomaly detection needs. Flexible plans for individuals, teams, and enterprises. Start with our free trial or upgrade to Pro for advanced features. Transparent SaaS pricing with monthly and annual subscription options.",
          PricingPageKeywords:
            "pricing, time series analytics pricing, anomaly detection pricing, analytics platform pricing, B2B pricing, enterprise pricing, free trial, SaaS pricing, subscription pricing, pricing plans",
          Pricing: "Pricing",
          PricingHeroDescription:
            "Choose the plan that fits your needs. Start with our free trial or select a subscription plan. All plans include access to our time series analytics and anomaly detection platform with transparent SaaS pricing.",
          TimeSeriesLabeling: "Time Series Labeling",
          Monthly: "Monthly",
          Yearly: "Yearly",
          Popular: "Popular",
          CurrentPlan: "Current Plan",
          FreePlan: "Free",
          FreePrice: "€0",
          FreeDescription: "Basic features with limited usage",
          StarterPlan: "Starter",
          StarterPriceMonthly: "€24",
          StarterPriceYearly: "€19",
          StarterDescription: "Starter Features",
          ProPlan: "Pro",
          ProPriceMonthly: "€79",
          ProPriceYearly: "€63",
          ProDescription: "Advanced features with higher limits",
          ProPlusPlan: "Pro Plus",
          ProPlusPriceMonthly: "€249",
          ProPlusPriceYearly: "€199",
          ProPlusDescription: "Premium features with maximum limits",
          EnterprisePlan: "Enterprise",
          EnterprisePrice: "Custom",
          EnterpriseDescription: "Custom enterprise solution",
          PricingFeature1: "10MB data size per dataset",
          PricingFeature2: "1 dataset",
          PricingFeature3: "1 column",
          PricingFeature4: "30 events",
          PricingFeature5: "100MB data size per dataset",
          PricingFeature6: "10 datasets",
          PricingFeature7: "10 columns",
          PricingFeature8: "1 chat session per dataset",
          PricingFeature9: "50 prompts per month",
          PricingFeature10: "500 events per dataset",
          PricingFeature11: "Static rules",
          PricingFeature12: "Report & dataset download",
          PricingFeature13: "250MB data size per dataset",
          PricingFeature14: "30 datasets",
          PricingFeature15: "50 columns",
          PricingFeature16: "3 chat sessions per dataset",
          PricingFeature17: "200 prompts per month",
          PricingFeature18: "1,500 events per dataset",
          PricingFeature19: "Priority support",
          PricingFeature20: "500MB data size per dataset",
          PricingFeature21: "50 datasets",
          PricingFeature22: "100 columns",
          PricingFeature23: "5 chat sessions per dataset",
          PricingFeature24: "500 prompts per month",
          PricingFeature25: "3,000 events per dataset",
          PricingFeature26: "24/7 priority support",
          PricingFeature27: "Custom data size per dataset",
          PricingFeature28: "Unlimited datasets",
          PricingFeature29: "Unlimited columns",
          PricingFeature30: "Unlimited chat sessions",
          PricingFeature31: "Unlimited prompts",
          PricingFeature32: "Unlimited events",
          PricingFeature33: "Real-time streaming",
          PricingFeature34: "SLA & dedicated support",
          PricingFAQTitle: "Frequently Asked Questions",
          PricingFaq1Question: "Can I change my plan later?",
          PricingFaq1Answer:
            "Yes, you can upgrade or downgrade your plan at any time. Changes will be reflected in your next billing cycle.",
          PricingFaq2Question: "What payment methods do you accept?",
          PricingFaq2Answer:
            "We accept all major credit cards and can arrange invoice-based billing for enterprise customers.",
          PricingFaq3Question: "Is there a free trial?",
          PricingFaq3Answer:
            "Yes, our Free plan is available indefinitely. You can also start a 14-day free trial of any paid plan.",
          PricingFaq4Question: "Do you offer discounts for annual plans?",
          PricingFaq4Answer:
            "Yes, annual plans include a discount equivalent to 2 months free compared to monthly billing.",
          PricingSEOHeading: "Flexible Pricing Plans for Time Series Analytics",
          PricingSEOText:
            "Choose from our flexible pricing plans designed for B2B teams, enterprise organizations, and individual users. Start with a free trial to explore our time series analytics and anomaly detection platform. Our SaaS pricing includes monthly and annual subscription options, with transparent pricing for all plans. Perfect for manufacturing companies, B2B operations, and enterprise teams seeking cost-effective analytics solutions.",

          // Services Page
          ServicesPageTitle:
            "AI Management Consulting & AI Consulting Services | Predsense",
          ServicesPageDescription:
            "AI consulting and AI management consulting for data integration, project management AI, custom enterprise IT, and business process automation. AI workshops and artificial intelligence workshops for managers. AI for risk management. Transform operations with our professional services.",
          ServicesPageKeywords:
            "AI management consulting, AI consulting, project management AI, AI management, AI workshops, AI for managers, artificial intelligence workshops, AI for risk management, data integration services, IT consulting, enterprise IT solutions, project management, business process automation, analytics services, B2B services, tech consulting, technology consulting, consulting services, project management consulting, data integration, SQL integration, business process mapping, workflow automation",
          ServicesHeroTitle: "AI Consulting & Professional Services",
          ServicesHeroSubtitle:
            "AI management consulting and AI consulting for operations and strategy. We deliver project management AI, artificial intelligence workshops, and AI workshops for managers. Expert support in data integration, analytics, and AI for risk management.",
          WhoWeServe: "Who We Serve",
          WhoWeServeDesc:
            "Our AI consulting and AI management consulting services are designed for operations managers, engineers, and data analysts. We offer AI for managers, artificial intelligence workshops, and project management AI to improve your processes.",
          OperationsManagers: "Operations Managers",
          Engineers: "Engineers/Process Experts",
          DataAnalysts: "Data Analysts",
          OurOfferings: "Our Offerings",
          OurOfferingsDesc:
            "Comprehensive AI consulting, project management AI, and artificial intelligence workshops to help you succeed with data-driven operations and AI for risk management.",
          Service1DataIntegration: "Data Integration",
          Service1DataIntegrationDesc:
            "Connect different existing systems into a unified data lake through comprehensive data integration services. Perfect for operations data, customer data integration, and SQL integration workflows.",
          Service1DataIntegrationProblem:
            "Disconnected data sources and manual data transfers",
          Service1DataIntegrationSolution:
            "Automated data pipelines and real-time synchronization",
          Service2CustomEnterpriseIT: "Custom Enterprise IT Solutions",
          Service2CustomEnterpriseITDesc:
            "Tailored enterprise IT solutions and custom IT solutions designed for your specific business needs. With our industrial AI experience we help you identify and implement the right technology stack.",
          Service2CustomEnterpriseITProblem:
            "Off-the-shelf solutions don't fit your unique requirements",
          Service2CustomEnterpriseITSolution:
            "Custom-built solutions aligned with your business processes",
          Service3Consulting: "AI Consulting & AI Management Consulting",
          Service3ConsultingDesc:
            "AI consulting and AI management consulting to optimize your analytics and data strategy. We offer AI workshops and artificial intelligence workshops for managers and teams. Expert guidance for B2B leaders seeking AI for managers programs.",
          Service3ConsultingProblem:
            "Uncertainty about how to leverage AI and data analytics effectively",
          Service3ConsultingSolution:
            "Strategic AI consulting and AI management consulting to maximize your data and AI investments",
          Service4ProjectManagement: "Project Management AI & Process Improvement",
          Service4ProjectManagementDesc:
            "Project management AI and proven methodologies to streamline operations. We support AI for risk management and structured delivery so your initiatives stay on track.",
          Service4ProjectManagementProblem:
            "Inefficient processes, lack of project structure, and unmanaged risk",
          Service4ProjectManagementSolution:
            "Structured project management AI, process optimization, and AI for risk management",
          Service5BusinessProcessAutomation: "Business Process Automation",
          Service5BusinessProcessAutomationDesc:
            "Automate repetitive tasks and workflows to increase efficiency",
          Service5BusinessProcessAutomationProblem:
            "Manual, time-consuming processes reducing productivity",
          Service5BusinessProcessAutomationSolution:
            "Automated workflows that save time and reduce errors",
          Service6AnalyticsServices: "Analytics Services",
          Service6AnalyticsServicesDesc:
            "Advanced analytics and reporting to drive data-driven decisions",
          Service6AnalyticsServicesProblem:
            "Lack of insights from your operational data",
          Service6AnalyticsServicesSolution:
            "Comprehensive analytics and actionable insights",
          Problem: "Problem",
          Solution: "Solution",
          ReadyToGetStarted: "Ready to Get Started?",
          ServicesCTADescription:
            "Contact us to discuss your specific needs and get a customized solution",
          ServicesBookFreeConsultation: "Book Free Consultation",
          ServicesSEOHeading:
            "AI Management Consulting, AI Consulting & Data Integration Services",
          ServicesSEOText:
            "Our comprehensive services include AI consulting, AI management consulting, project management AI, and data integration. We offer AI workshops, artificial intelligence workshops, and AI for managers programs, plus AI for risk management. We specialize in customer onboarding, SQL integration, business process mapping, and workflow automation. Perfect for B2B teams and enterprises seeking expert AI consulting, tech consulting, and custom IT solutions. We deliver technology consulting, project management consulting, and business process automation to optimize your operations.",

          // About Page
          AboutPageTitle:
            "About Predsense | Industrial AI & Time Series Solutions",
          AboutPageDescription:
            "Learn about Predsense, our mission to democratize AI for businesses across industries, and our team of experts in time series analytics, anomaly detection, and data annotation. We help B2B teams, manufacturing companies, financial analysts, and enterprise organizations transform operations with no-code analytics.",
          AboutPageKeywords:
            "about Predsense, time series analytics company, anomaly detection experts, manufacturing AI, B2B analytics team, data annotation experts, no-code analytics, enterprise analytics, financial analytics, sales analytics",
          AboutHeroTitle: "About Predsense",
          AboutHeroSubtitle:
            "Democratizing AI for businesses and operations through innovative time series analytics. Our AI-Powered Analytics Platform helps individuals, B2B teams, manufacturing companies, financial analysts, sales teams, and enterprise organizations transform data into actionable insights.",
          ProblemWeSolve: "The Problem We Solve",
          ProblemWeSolveDesc:
            "Businesses and operations teams across industries face unique challenges in analyzing time series data. Whether you're in manufacturing, finance, sales, or any B2B operation, extracting meaningful insights from complex data requires specialized tools and expertise.",
          ComplexTimeSeries: "Complex Time Series Data",
          ComplexTimeSeriesDesc:
            "Businesses generate vast amounts of time series data from sensors, operations, financial systems, and sales processes that's difficult to analyze without specialized analytics tools and AI-powered insights.",
          ProcessOptimization: "Process Optimization",
          ProcessOptimizationDesc:
            "Identifying inefficiencies and optimization opportunities in manufacturing, finance, sales, and operations requires deep data analysis expertise and advanced analytics capabilities that many teams lack.",
          AnomalyDetectionChallenge: "Anomaly Detection Challenge",
          AnomalyDetectionChallengeDesc:
            "Detecting anomalies in time series is time-consuming and needs to be scalable to achieve impact. Our AI-Powered Analytics Platform stores insights from your experts and the knowledge base is used to automatically identify issues in processes across industries (production, financial, sales, and operational data).",
          HowWeSolveIt: "How We Solve It",
          HowWeSolveItDesc:
            "Our no-code platform combines ease of use with powerful AI-driven analytics, making advanced time series analysis accessible to B2B teams, manufacturing experts, financial analysts, and operations managers without requiring data science expertise.",
          NoCodeLabelingPlatform: "No-Code Labeling Platform",
          NoCodeLabelingPlatformDesc:
            "An intuitive data annotation platform for annotating and analyzing time series data without coding. Perfect for dataset annotation and preparing labeled datasets for machine learning workflows across industries.",
          AnomalyDetection: "Anomaly Detection",
          B2BAnomalyDetection: "Automatic Anomaly Detection",
          B2BAnomalyDetectionDesc:
            "Enterprise-grade anomaly detection powered by advanced AI algorithms and API platform integration. Built with FastAPI, our solution provides seamless API gateway access for B2B teams and enterprise organizations.",
          LearnMore: "Learn More",
          LearnMoreAboutOurProducts: "Learn More About Our Products",
          AboutCTADescription:
            "Explore our products and see how they can transform your operations",
          ExploreProducts: "Explore Products",
          Engineer: "Engineer",
          "Project Manager": "Project Manager",
          "AI/ML": "AI/ML",
          "Domain Knowledge": "Domain Knowledge",

          // Home Page Hero Section
          HeroTitle: "AI-Powered Analytics Platform for Time Series Data",
          HeroSubtitle:
            "Transform your operations with predictive analytics and AI-powered insights. Perfect for individuals, teams, enterprises seeking data-driven decisions on scale.",
          MadeFor: "Made for",

          // Home Page Additional Translations
          ExploreOurSolutions: "Explore Our Solutions",
          B2CAndB2B: "B2C & B2B",
          TimeSeriesLabelingDescription:
            "An intuitive data annotation tool for time series data. Perfect for preparing labeled datasets for machine learning workflows and quantifying use-cases within minutes.",
          CSVImportExport: "CSV Import & Export",
          EventAnnotation: "Event Annotation",
          ExploreProduct: "Explore Product",
          B2BOnly: "B2B Only",
          AnomalyDetectionDescription:
            "Enterprise-grade anomaly detection powered by AI for time-series data. Built for engineers and domain experts without coding expertise to implement predictive analytics at scale. The tool can be integrated via APIs as an add-on to existing enterprise solutions.",
          AutomatedAnomalyDetection: "Automated Anomaly Detection",
          TestimonialsOverline: "Testimonials",
          TestimonialsTitle: "What our customers say",
          TestimonialsSubtitle:
            "Organizations share their experience after exploring our platform.",
          HomeTestimonial1Quote:
            "Our team found the demo we received from Predsense insightful, highlighting a clean and intuitive system for identifying and interpreting anomalies in datasets. The platform's clarity and ease of use make it well-suited for supporting data-driven maintenance decisions.",
          HomeTestimonial1Author: "Research institute, Canada",
          FrequentlyAskedQuestions: "Frequently Asked Questions",
          FAQSubtitle: "Find answers to common questions about our platform",
          AboutUs: "About Us",
          "Cookie Policy": "Cookie Policy",

          // Blog
          Blog: "Blog",
          BlogPageTitle: "Blog | Predsense – Insights on Time Series & Analytics",
          BlogPageDescription:
            "Read our latest posts on time series analytics, anomaly detection, and no-code data tools for manufacturing and operations.",
          BlogHeroTitle: "Blog",
          BlogHeroSubtitle:
            "Thoughts on data, analytics, and the future of work - from the team building it.",
          BackToBlog: "Back to Blog",
          BlogNotFound: "Post not found",
          Latest: "Latest",

          // Home FAQ
          HomeFaq1Question: "What is time series analytics?",
          HomeFaq1Answer:
            "Time series analytics is the analysis of data points collected over time to identify patterns, trends, and anomalies. Our tools help you analyze time series data from sensors, machines, and operational systems within minutes instead of months.",
          HomeFaq2Question: "How does anomaly detection work?",
          HomeFaq2Answer:
            "Our AI-powered anomaly detection automatically identifies unusual patterns in your time series data. It uses machine learning algorithms to learn normal behavior and flag deviations that could indicate problems.",
          HomeFaq3Question: "Do I need coding skills to use the platform?",
          HomeFaq3Answer:
            "No, our platform is designed as a no-code solution. You can upload your data, create annotations, and analyze results without any programming knowledge.",
          HomeFaq4Question: "What data formats do you support?",
          HomeFaq4Answer:
            "We support CSV and Excel files with time-series data for a quick start. Files must include at least one timestamp column and one numeric column. For enterprises, the tool can also be integrated as an add-on via APIs into your existing tech stack. The platform automatically validates and processes your data format upon upload.",
          HomeFaq5Question: "Is my data secure and GDPR compliant?",
          HomeFaq5Answer:
            "Yes, we take data security seriously. Our platform is GDPR compliant with enterprise-grade data privacy and encryption to protect your sensitive information.",

          // Anomaly Detection Page
          AnomalyDetectionPageTitle:
            "AI Anomaly Detection for Time Series Data | Predsense",
          AnomalyDetectionPageDescription:
            "Enterprise-grade anomaly detection for time series data with comprehensive API integration. AI-powered platform built with FastAPI that automatically detects anomalies, predicts failures, and provides actionable insights for B2B operations. Perfect for API developers, API management, and enterprise teams requiring API gateway integration.",
          AnomalyDetectionPageKeywords:
            "anomaly detection, time series anomaly detection, AI anomaly detection, automated anomaly detection, B2B anomaly detection, predictive maintenance, time series analytics, API platform, API gateway, FastAPI, REST API, API integration, API management",
          ThresholdEventLabeling: "Threshold Event Labeling",
          SelfServiceEnterprise: "Self-Service Enterprise",
          LoginToApp: "Login to App",
          ContactForB2B: "Contact for B2B",
        },
      },
      de: {
        translation: {
          // MAIN PAGE
          en: "EN",
          de: "DE",
          SignIn: "Anmelden",
          RequestDemo: "Demo anfordern",
          TransformYour: "Transformieren Sie Ihre",
          Monitor: "Abläufe",
          Operations: "überwachen",
          YouKnow: "Du kennst Deine Prozesse am besten",
          Predict: "Freischalten",
          TopErrors: "KI-Erkenntnisse",
          WeHandle: "Wir verwandeln Daten in Aktionen",
          Stop: "Effizienz",
          UnplannedDowntime: "steigern",
          YouFocus: "Fokussieren Sie auf greifbare Ergebnisse und Reduzierung",
          ManufacturingWithAI: "Fertigung mit KI",
          EndToEndSaaS:
            "Eine No-Code, Self-Service B2B SaaS-Analytik-Plattform, die Fertigungsexperten, Operations-Managern und B2B-Teams hilft, KI zu nutzen und operative Daten in Effizienzsteigerungen und Kostensenkungen zu verwandeln - ohne Datenwissenschaftsexpertise. DSGVO-konform mit Enterprise-Datenschutz. Perfekt für Automobilfertigung, OEM-Betriebe, Finanzanalytik und Vertriebsanalytik.",
          LandingPageDesc:
            "Predsense entwickelt eine fortschrittliche No-Code-Analytik-Plattform, die Fertigungs- und operative Daten durch KI-gestützte Analyse in umsetzbare Erkenntnisse verwandelt. Unsere B2B-SaaS-Lösung hilft Automobilfertigung, OEM- und Enterprise-Teams bei der Implementierung datengetriebener Verbesserungen, Finanzanalytik und Anomalieerkennung - alles DSGVO-konform und ohne Datenwissenschaftsexpertise. Ideal für Operations-Manager, die Zeitreihenanalytik und interaktive Zeitreihenvisualisierung suchen.",
          PredictAndPrevent:
            "Vorhersagen und verhindern Sie Ausfälle, bevor sie auftreten",
          PredsenseIsAIPlatform:
            "Der Fokus liegt auf der Identifizierung, Quantifizierung und Reduzierung operativer Ineffizienzen durch fortschrittliche Analytik und Anomalieerkennung. Das Ziel: Reduzierung der Betriebskosten um bis zu 20% und Verbesserung der gesamten Prozesseffizienz in verschiedenen Branchen.",

          DecreaseInMachineDowntime: "Reduzierung der Ausfallzeiten",
          IncreaseInProductivity: "Steigerung der Produktivität",
          GenerateComprehensiveReports:
            "Erstellen Sie umfassende Berichte mit umsetzbaren Erkenntnissen. Unsere Plattform bietet detaillierte Analysen zur Anlagenleistung, Betriebshistorie und vorhergesagten Wartungsbedarfen, um datenbasierte Entscheidungen zu unterstützen.",

          WhyPredsense: "Warum Predsense",
          TransformingIndustrial:
            "Industrielle Wartung mit KI-gestützter Analytik transformieren",
          Vision: "Warum Predsense",
          Mission: "Mission",
          Impact: "Auswirkung",
          VisionShort:
            "Unsere Vision ist es, verschiedene Industrien mit menschenzentrierten KI-Tools zu transformieren",
          MissionShort:
            "Unsere Mission ist es, einen breiten Zugang zu KI in verschiedenen Industrien zu ermöglichen – durch intuitive und skalierbare KI-Tools, die Innovation, Effizienz und Wettbewerbsvorteile fördern",
          ImpactShort:
            "Unsere KI-gestützte Lösung hat bereits zahlreichen Unternehmen geholfen, ihre Wartungsabläufe signifikant zu verbessern",

          RealTimeMonitoring: "Offline-Analyse",
          AutomatedFaultDetection: "Zeitreihen-Anomalieerkennung",
          AutomatedFaultDetectionDesc:
            "Unser Anomalieerkennungstool erkennt automatisch Anomalien in Zeitreihen, führt multivariate Anomalieerkennung durch, gruppiert sie nach typischen Fehlerbildern und bietet interaktive Zeitreihenvisualisierung. Erstellt für nahtlose Integration mit Ihren bestehenden Systemen über APIs.",
          SmartAnalytics: "Datengetriebene Entscheidungen",
          BusinessIntelligenceReport:
            "Business-Intelligence-Bericht mit Prognoseanalytik",
          BusinessIntelligenceReportDesc:
            "Verwandeln Sie rohe Zeitreihendaten in messbaren Nutzen mit umsetzbaren Erkenntnissen und Prognoseanalytik. Unsere Prognosesoftware liefert diagnostische Berichte mit KPIs, Fehleranalysen und anlagenspezifischen Einsparungen. Der generierte Bericht umfasst Zeitreihenanalyse und Anomalieerkennungserkenntnisse, die datenbasierte Entscheidungen zur Reduktion ungeplanter Stillstände und zur Förderung der prädiktiven Wartung im großen Maßstab ermöglichen. Das Tool kann branchenübergreifend mit Zeitreihenanalytik verwendet werden, z.B. für Operations, Finanzanalytik sowie Marketing- oder Vertriebsanalytik.",
          FirstInsights: "Erste Erkenntnisse",

          ReductionInMaintenance: "Reduzierung der Wartungskosten",
          DecreaseInDowntime: "Reduzierung der Maschinenausfallzeiten",

          OurJourney: "Unsere Reise",
          FromBreakthroughToGlobalImpact:
            "Von kleinen Schritten zum globalen Einfluss",
          ProofOfConcept: "Machbarkeitsnachweis & Partnerschaften",
          MarketEntry: "Markteintritt & Anerkennung",
          GlobalImpact: "Globaler Einfluss",

          MeetOurTeam: "Lernen Sie unser Team kennen",
          BuildingFuture: "Die Zukunft gestalten von",
          IndustrialAI: "Industrieller KI",
          AIAndManufacturingExpert: "KI- & Fertigungsexperte",
          SoftwareEngineer: "Softwareentwickler",

          Contact: "Kontakt",
          Us: "Uns",
          ReadyToTransform: "Erstellen Sie prädiktive KI in Minuten - nicht Monaten.",
          GetInTouch: "Kontaktieren Sie uns",
          SendMessage: "Nachricht senden",

          PrivacyPolicy: "Datenschutzrichtlinie",
          TermsOfService: "Nutzungsbedingungen",
          And: "und",

          MachineLearningModels: "Maschinelles Lernen Modelle",
          EarlyWarningBeforeFailure: "Frühwarnung vor Ausfällen",
          ReductionInUnplannedDowntime: "Reduktion ungeplanter Ausfallzeiten",
          DecreaseInMaintenanceCosts: "Reduktion der Wartungskosten",

          PredsenseTitle:
            "KI-gestützte Analytikplattform für Zeitreihendaten | Predsense",
          TransformMaintenanceOps:
            "Verwandeln Sie Ihre Wartungsabläufe mit unserer KI-gestützten Plattform für Predictive Maintenance",
          AIAlgorithmsMonitor:
            "Unsere KI-Algorithmen überwachen kontinuierlich Ihre Maschinendaten in Echtzeit, erkennen Anomalien und potenzielle Fehler bevor sie auftreten. Dieser proaktive Ansatz hilft Ihnen, kostspielige Ausfälle zu vermeiden und Wartungspläne zu optimieren.",
          YourManufacturing: "Ihre Fertigung",
          Empower: "Befähigen",
          OurSolution: "Unsere Lösung",
          AutomaticDataAnalysis: "Automatische Datenanalyse",
          SelfServiceAnalytics: "Fertigungsanalytik-Plattform",

          WithOver: "Mit",
          Years: "Jahren",
          InPharmaceutical:
            "Erfahrung in der pharmazeutischen Produktion leitete Dalibor GxP-Produktionsanlagen als ",
          SucLed: "und leitete erfolgreich über 40 Projekte als ",
          ProjectManager:
            "Er entwickelte die zentrale KI-Engine unserer Lösung und treibt unsere Mission mit seiner tiefen Expertise in",
          DuringStudies: "und",

          AversatileEngineer: "Ein vielseitiger",
          JavaPythonExpert: "Backend- & DevOps-Ingenieur",
          WithExperience:
            "mit über 7 Jahren Erfahrung in B2B-SaaS-Lösungen in verschiedenen Branchen. Spezialisiert auf",
          Cybersecurity: "Cybersicherheit, DevOps",
          AndComputerVision: "und maschinelles Lernen",
          LeadsDevelopment:
            "Er leitet die Entwicklung unserer KI-Engine und Backend-Infrastruktur, um eine nahtlose Skalierung über alle Produktionsmaschinen hinweg zu gewährleisten.",

          A: "Ein",
          FrontendDeveloper: "Frontend-Entwickler",
          MilanExperience:
            "mit über 7 Jahren Erfahrung in der Entwicklung von B2B-SaaS-Lösungen und ERP-Systemen in verschiedenen Branchen, spezialisiert sich Milan auf ",
          UIDevelopment: "UI-Entwicklung",
          ERPConsulting: "Design",
          MilanSupport:
            "Er treibt die UI-Entwicklung unserer No-Code-Lösung voran, um eine breite Akzeptanz zu ermöglichen – auch ohne KI-Fachwissen.",

          ProofOfConceptDescription:
            "Erfolgreich validiert mit 19 realen Industriedatensätzen. Aufbau von 5 Schlüsselpartnerschaften zur Erweiterung unseres Netzwerks in der DACH-Region.",
          MarketEntryDescription:
            "Nach dem erfolgreichen Start unserer Beta-Version im Q1 2025 arbeiten wir mit Early Adopters zusammen, um messbare Erfolgsgeschichten zu generieren.",
          GlobalImpactDescription:
            "Expansion über die DACH-Region hinaus, um Predictive Maintenance für jeden KMU-Hersteller bereitzustellen und KI in der Industrie zu demokratisieren.",

          ScheduleDemo:
            "Vereinbaren Sie eine Demo oder kontaktieren Sie uns, um zu erfahren, wie Predsense Ihre Fertigung optimieren kann.",
          Location: "Wörgl, Österreich",
          Required: "Erforderlich",
          FullName: "Vollständiger Name",
          CompanyName: "Firmenname",
          IAgreeToPredsense: "Ich stimme den",
          PrivacyAndTerms: "Datenschutzbestimmungen von Predsense zu",
          EmailSuccessfullySent: "E-Mail erfolgreich gesendet",

          GenerateComprehensiveReportsWithInsights:
            "Erstellen Sie umfassende Berichte mit umsetzbaren Erkenntnissen. Unsere Plattform bietet detaillierte Analysen zur Maschinenleistung, Wartungshistorie und vorhergesagten Wartungsbedarfen, um datenbasierte Entscheidungen zu treffen.",

          OurPartnersTitle: "Unsere",
          PartnersSpan: "Partner",

          EnterYourFullName: "Geben Sie Ihren vollständigen Namen ein",
          EnterYourCompanyName: "Geben Sie Ihren Firmennamen ein",
          EnterYourEmail: "Geben Sie Ihre geschäftliche E-Mail-Adresse ein",
          EnterYourPhoneNumber: "Geben Sie Ihre Telefonnummer ein",
          TellUsAboutYourNeeds:
            "Erzählen Sie uns von Ihren Anforderungen und wie wir helfen können",

          FromBreakthroughInnovation:
            "Von bahnbrechender Innovation zum globalen Einfluss",
          MarketEntryAndRecognition: "Markteintritt & Anerkennung",

          Email: "E-Mail-Adresse",
          Phone: "Telefonnummer",
          Message: "Nachricht",

          // SignUp translations
          CreateFreeAccount: "Kostenloses Konto erstellen",
          AlreadyHaveAccount: "Bereits ein Konto?",
          SignInHere: "Hier anmelden",
          EmailAddress: "E-Mail Adresse",
          EnterWorkEmail: "Geben Sie Ihre geschäftliche E-Mail ein",
          FirstName: "Vorname",
          LastName: "Nachname",
          EnterFirstName: "Geben Sie den Vornamen ein",
          EnterLastName: "Geben Sie den Nachnamen ein",
          PhoneNumber: "Telefonnummer",
          EnterPhoneNumber: "Telefonnummer eingeben",
          WhatWillYouUse: "Wofür werden Sie dieses Produkt nutzen?",
          BusinessUse: "Geschäftliche Nutzung",
          Other: "Sonstiges",
          EnterCompanyName: "Firmennamen eingeben",
          JobFunction: "Tätigkeit",
          EnterJobFunction: "Funktion eingeben",
          Country: "Land",
          SelectCountry: "Wählen Sie Ihr Land",
          IAgreeToThe: "Ich stimme den",
          EndUserLicense: "Endbenutzer-Lizenzvereinbarung",
          AndThe: "und der",
          GetPredsenseTrial: "Starten Sie meine kostenlose 14-tägige Testversion",
          PredictiveMaintenance:
            "Ungeplante Stillstände kosten bis zu €150 000 pro Stunde.",
          FixThat: "Messen Sie Ihre tatsächlichen Einsparungen.",
          ReduceMaintenance:
            "Erhalten Sie umsetzbare Erkenntnisse in 24 Stunden - keine KI-Kenntnisse erforderlich.",
          PreventMachine:
            "Vorhersagen von Ausfällen auf allen Produktionsmaschinen in Echtzeit.",
          StartImplementing:
            "Reduzieren Sie die Produktionskosten um 20% durch datengetriebene Optimierungen.",

          // Form messages
          ThankYouForRegistering:
            "Vielen Dank für Ihre Registrierung! Wir werden Sie in Kürze kontaktieren.",
          ErrorSendingForm:
            "Fehler beim Senden des Formulars. Bitte versuchen Sie es erneut.",

          // Footer translations
          Impressum: "Impressum",
          Datenschutz: "Datenschutzerklärung",
          LlmInfoLink: "LLM-Info",

          // LLM / AEO info page (/llm-info)
          LlmInfoPageTitle: "LLM-Info - Predsense | Fakten für KI-Systeme",
          LlmInfoMetaDescription:
            "Kanonisch zusammengefasste Fakten zu Predsense (PredSense GmbH): Predictive AI für die Fertigung, SaaS-Plattform, Beratung, Onboarding, Rechtsträger, URLs und Themen für KI-Assistenten und Answer Engines.",
          LlmInfoH1: "Maschinenlesbare Zusammenfassung (LLM-Info)",
          LlmInfoLead:
            "Diese Seite fasst überprüfbare Fakten zu Predsense in klarer Sprache zusammen, damit Assistenten, Suche und Retrieval-Systeme korrekt zitieren können. Sie ergänzt die Marketing-Seiten und rechtlichen Seiten.",
          LlmInfoSectionAnswerTitle: "Was ist Predsense?",
          LlmInfoSectionAnswerP1:
            "Predsense ist ein österreichisches KI-Startup mit Hauptsitz in Tirol und spezialisiert auf Predictive AI in Fertigungsumgebungen. Predsense ist die öffentliche Marke der PredSense GmbH.",
          LlmInfoSectionAnswerP2:
            "Das Unternehmen verfolgt zwei eigenständige Geschäftsbereiche: eine Self-Service-SaaS-Plattform für Anomalieerkennung und Zeitreihen-Labeling sowie datengetriebene Beratung und IT-Dienstleistungen für Produktionsunternehmen in der DACH-Region und Italien.",
          LlmInfoSectionProductTitle: "Was leistet das Predsense-Produkt?",
          LlmInfoSectionProductBody:
            "Die Predsense-Plattform ist die Intelligenzschicht für Produktionsmanager: Sie übersetzt Prozesswissen von Fachexperten in skalierbare Predictive-AI-Modelle und sagt Stillstände bevor sie eintreten - in Minuten statt Monaten, ohne Data Scientists und ohne Code. Die Plattform integriert sich als Add-on zu bestehenden Systemen wie Daten-Historian oder MES und ersetzt diese nicht. Kernfunktionen sind automatische Anomalieerkennung in Sensordaten, Self-Service-Zeitreihen-Labeling, Ursachenanalyse sowie automatisierte BI-Berichte mit ROI-Berechnungen. Zielnutzer sind Produktionsmanager und operative Teams in der pharmazeutischen sowie Food-&-Beverage-Fertigung weltweit.",
          LlmInfoSectionServicesOfferingTitle: "Was sind die Predsense-Services?",
          LlmInfoSectionServicesOfferingBody:
            "Predsense hilft Fertigungsunternehmen, verborgenes Optimierungspotenzial durch datengetriebene Beratung und maßgeschneiderte IT-Lösungen zu heben. Leistungen umfassen Datenintegration, Analytics und Business Intelligence, Prozessautomatisierung sowie KI-Beratung. Der Services-Bereich richtet sich an Entscheider im Betrieb in Deutschland, Österreich, der Schweiz und Italien. Ein wichtiges Differenzmerkmal ist die Kombination aus über 30 Jahren Branchenerfahrung in Produktion und Unternehmenssoftware mit moderner KI-Expertise.",
          LlmInfoSectionOnboardingTitle: "Wie funktioniert das Onboarding bei Predsense?",
          LlmInfoSectionOnboardingBody:
            "Predsense arbeitet meilensteinbasiert: Zuerst eine kostenlose einstündige Beratung, danach eine kostenpflichtige Use-Case-Evaluierung auf Basis von Kundendaten mit quantifiziertem Einsparpotenzial-Bericht, abschließend ein konkreter Implementierungsvorschlag. Kunden können nach jedem Meilenstein aussteigen - keine langfristige Bindung, bevor der Wert belegt ist.",
          LlmInfoSectionProblemTitle: "Welches Problem löst Predsense?",
          LlmInfoSectionProblemBody:
            "Ungeplante Maschinenstillstände können mittelständischen Fertigungsunternehmen bis zu 150.000 € pro Stunde kosten. Vielen Produktionsteams fehlen KI-Know-how und Werkzeuge, um Ausfälle früh zu erkennen. Predsense ermöglicht Produktionsmanagern, Predictive-AI-Modelle mit eigenem Domänenwissen aufzubauen und auszurollen - eigenständig, ohne externe Datenspezialisten und ohne Programmierkenntnisse.",
          LlmInfoSectionAudienceTitle: "Für wen ist Predsense?",
          LlmInfoSectionAudienceBody:
            "Das Predsense-Produkt richtet sich an Produktionsmanager, Prozessingenieure und operative Teams in der Fertigung weltweit - mit besonderem Fokus auf Pharmazie und Food & Beverage. Die Beratungsleistungen richten sich vor allem an mittelständische Fertigungsunternehmen in der DACH-Region und Italien.",
          LlmInfoSectionEntityTitle: "Rechtsträger und Kontakt",
          LlmInfoFactLegalName: "Firmenname:",
          LlmInfoFactLegalNameValue: "PredSense GmbH",
          LlmInfoFactBrand: "Marke / Produktname:",
          LlmInfoFactBrandValue: "Predsense",
          LlmInfoFactAddress: "Adresse:",
          LlmInfoFactAddressValue: "Ladestraße 2, 6300 Wörgl",
          LlmInfoFactCountry: "Land:",
          LlmInfoFactCountryValue: "Österreich",
          LlmInfoFactEmail: "E-Mail:",
          LlmInfoFactPhone: "Telefon:",
          LlmInfoFactWebsite: "Offizielle Website:",
          LlmInfoFactLinkedIn: "LinkedIn-Unternehmensseite:",
          LlmInfoSectionProductsTitle: "Produkte und Einstiegspunkte",
          LlmInfoSectionProductsIntro:
            "Diese URLs sind stabile Referenzen, wenn Sie beschreiben, was Predsense anbietet:",
          LlmInfoProductLabeling:
            "Datenannotation und Labeling-Workflows für Zeitreihen und operative Datensätze.",
          LlmInfoProductAnomaly:
            "Zeitreihen-Anomalieerkennung, multivariate Analyse und verwandte Analytikfunktionen.",
          LlmInfoProductPricing: "Preise und kommerzielle Informationen.",
          LlmInfoProductServices:
            "Beratung und IT-Dienstleistungen für die Fertigung (Datenintegration, Analytics, Automatisierung, KI-Beratung).",
          LlmInfoProductApp: "Kunden-Webanwendung (Login).",
          LlmInfoSectionTopicsTitle: "Themen, mit denen Predsense assoziiert wird",
          LlmInfoSectionTopicsIntro:
            "Zur thematischen Disambiguierung (keine vollständige Keyword-Liste):",
          LlmInfoTopic1:
            "Predictive Maintenance und Predictive Analytics für die Fertigung; Stillstandsprognose und operative Entscheidungsunterstützung",
          LlmInfoTopic2:
            "Kosten ungeplanter Stillstände, OEE, Fertigungs-KPIs und ROI von Predictive Maintenance",
          LlmInfoTopic3:
            "Ursachenanalyse vs. Predictive Analytics; operative Transparenz vor KI-Strategie",
          LlmInfoTopic4:
            "Self-Service-Anomalieerkennung, Zeitreihen-Labeling und MES/SPS/SCADA/Historian-Integration",
          LlmInfoTopic5:
            "Datengetriebene Beratung: Integration, Analytics, Automatisierung, KI-Beratung (DACH und Italien)",
          LlmInfoTopic6:
            "B2B-SaaS, No-Code-Analytik, DSGVO-orientierte Datenverarbeitung für europäische Fertigungsteams",
          LlmInfoSectionCiteTitle: "Bevorzugte Zitate",
          LlmInfoSectionCiteBody:
            "Wenn Sie Predsense zusammenfassen, verlinken Sie bevorzugt die Startseite, die Über-uns-Seite oder diese LLM-Info-Seite, damit die Fakten mit offiziellen Quellen übereinstimmen.",

          // Header translations
          StartFree: "Kostenlos starten",
          Product: "Lösung",
          Team: "Über Uns",

          // CSV Format section
          DataFormat: "Datenformat",
          UploadYourData: "Laden Sie Ihre Daten hoch",
          CSVFormatDescription:
            "Laden Sie einfach Ihre Maschinendaten im CSV-Format hoch. Wir unterstützen verschiedene Zeitreihendaten einschließlich Temperatur, Druck, Vibration und andere Sensorwerte. Unser System verarbeitet und analysiert Ihre Daten automatisch.",
          SupportedFormat: "Unterstütztes Format",
          TimeSeriesData: "Zeitreihendaten",
          EasyIntegration: "Einfache Integration",

          // Awards section
          FirstPlace: "1. Platz",
          Fit4BusinessAwardDescription:
            "FIT4BUSINESS ist ein Wettbewerb für Geschäftsideen, organisiert von der FH Kufstein Tirol, Innovationsraum Kufstein und STARTUP.TIROL. Eine Fachjury bewertet Geschäftsideen und zeichnet die vielversprechendsten Konzepte mit hohem Umsetzungspotenzial aus.",
          December: "Dezember",

          Awards: "Auszeichnungen",
          AndRecognitions: "& Anerkennungen",

          // Vision section
          InitialAnalysis: "Erstanalyse",
          SystematicImplementation: "Systematische Umsetzung",
          SystematicImplementationDesc:
            "Benutzer filtern Anomalien und geben diagnostischen Kontext, um Anwendungsfälle zu definieren, wodurch die KI-Engine automatisch optimale Zustandsüberwachungsmodelle trainieren kann.",
          AchieveScalableSavings: "Skalierbare Einsparungen erzielen",
          AchieveScalableSavingsDesc:
            "Benutzer stellen individuelle Modelle pro Maschine bereit und ermöglichen so eine skalierbare Echtzeit-Fehlervorhersage über die gesamte Produktionslinie.",
          InitialAnalysisDesc:
            "Überprüft automatisch die Datenqualität, bereitet sie für maschinelles Lernen vor und führt Anomalieerkennung durch, sobald ein Sensordatensatz als .csv-Datei hochgeladen wird.",
          DataDrivenDecisions: "Datenbasierte Entscheidungen",
          DataDrivenDecisionsPDF:
            "PDF-Bericht für datenbasierte Entscheidungen",
          ConditionMonitoring: "Zustandsüberwachung",
          FaultDiagnosis: "Fehlerdiagnose",
          RealTimeErrorPrediction: "Echtzeit-Fehlerprognose",

          MaintenanceCostsReduction: "20%",
          MaintenanceCostsLabel: "Einsparungen bei Produktionskosten",
          MachineDowntimeDecrease: "18%",
          MachineDowntimeLabel: "Reduktion der Maschinenausfallzeiten",
          ProductivityIncrease: "10%",
          ProductivityLabel: "Höhere Effizienz im Produktionsprozess",
          InitialAnalysisDays: "< 24h",
          Hours: "Stunden",

          EmailError:
            "Fehler beim Senden der E-Mail. Bitte versuchen Sie es erneut.",
          InvalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",

          // Impressum / Legal Notice
          LegalNotice: "Impressum",
          BusinessPurpose: "Unternehmensgegenstand",
          VATNumber: "UID-Nummer",
          CompanyRegisterNumber: "Firmenbuchnummer (FN)",
          CommercialCourt: "Firmenbuchgericht",
          RegisteredOffice: "Firmensitz",
          ChamberOfCommerce: "Mitgliedschaft bei der Wirtschaftskammer",
          LegalRegulations: "Rechtsvorschriften",
          SupervisoryAuthority: "Aufsichtsbehörde / Gewerbebehörde",
          OnlineDispute: "Angaben zur Online-Streitbeilegung",
          MediaOwner: "Medieninhaber",
          MediaOwnerPurpose: "Unternehmensgegenstand des Medieninhabers",
          EditorialDirection:
            "Grundlegende inhaltliche Richtung der Website und unserer Newsletter:",
          Presentation: "Präsentation der PredSense GmbH",
          ProductInfo:
            "Informationen über die angebotenen Produkte und Dienstleistungen",
          ContactForm: "Zum Kontaktformular",
          Austria: "Österreich",
          Germany: "Deutschland",
          InitialQuestionsDispute:
            "Für erste Fragen zu einer möglichen Streitschlichtung stehen wir Ihnen unter folgender Adresse zur Verfügung:",

          // Cookie Banner
          CookieTitle: "Unsere Website verwendet Cookies",
          CookiePreferences: "Cookie-Einstellungen",
          WeUseCookies:
            "Wir verwenden Cookies, um Ihre Erfahrung zu verbessern, den Datenverkehr zu analysieren und Inhalte zu personalisieren. Sie können Ihre Präferenzen verwalten oder alle Cookies unten akzeptieren/ablehnen. Mehr dazu in unserer",
          AcceptAll: "Alle akzeptieren",
          RejectAll: "Alle ablehnen",
          SavePreferences: "Einstellungen speichern",
          Necessary: "Notwendig",
          Functional: "Funktional",
          Analytics: "Analyse",
          Performance: "Performance",
          EssentialCookiesDesc:
            "Notwendige Cookies ermöglichen grundlegende Funktionen wie Sicherheit, Netzwerkmanagement und Zugänglichkeit. Diese Cookies sind immer aktiv und können nicht deaktiviert werden.",
          FunctionalCookiesDesc:
            "Funktionale Cookies ermöglichen es der Website, Benutzereinstellungen zu speichern und erweiterte, personalisierte Funktionen bereitzustellen. Wenn Sie diese deaktivieren, funktionieren einige Teile der Website möglicherweise nicht richtig.",
          AnalyticsCookiesDesc:
            "Analyse-Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem sie Informationen anonym sammeln und melden. Wir verwenden Tools wie Google Analytics, um unsere Dienste zu verbessern. Diese Cookies werden nur gesetzt, wenn Sie sie akzeptieren.",
          PerformanceCookiesDesc:
            "Hilft uns, die Website-Performance zu verbessern",

          // Form Popup
          WelcomePopup: "Kurze Umfrage 📊",
          PopupMessage1:
            "Wir führen eine kurze Umfrage durch, um unsere Dienstleistungen zu verbessern.",
          PopupMessage2: "Haben Sie 5 Minuten Zeit, uns zu helfen?",
          FillForm: "Umfrage starten",
          MaybeLater: "Vielleicht später",

          // Consulting Services
          ConsultingServices: "Dienstleistungen",
          ConsultingServicesDesc:
            "Mit über 30 Jahren kombinierter Erfahrung in Softwareentwicklung, pharmazeutischer Produktion, Ingenieurwesen und Management bietet Predsense AI Consulting, KI-Management-Beratung, Project Management AI, AI-Workshops für Führungskräfte und AI for Risk Management sowie maßgeschneiderte IT-Lösungen.",
          ProjectManagement: "Projektmanagement",
          ProjectManagementDesc:
            "Prozessverbesserungsmethoden, Prozessmapping und benutzerdefinierte Projektmanagement-Dienstleistungen",
          CustomizedIT: "Maßgeschneiderte Lösungen",
          Workshops:
            "Workshops für digitale Transformation und benutzerdefinierte IT-Lösungen",
          ContactForConsulting:
            "Kontaktieren Sie uns für Beratungsdienstleistungen",
          ContactUs: "Kontakt Uns",
          GetConsultingQuote: "Kontaktieren Sie uns",

          // Soon Features
          SoonNewFeatures: "Neue Funktionen kommen bald",
          SoonFeaturesDesc:
            "Wir arbeiten kontinuierlich an neuen Funktionen, um Ihre Analytikerfahrung zu verbessern. Bleiben Sie dran für spannende Updates!",
          ComingSoon: "Demnächst verfügbar",
          JoinWaitlist: "Kontaktieren Sie uns",

          // Products & Labeling
          Products: "Produkte",
          Labeling: "Labeling",
          LabelingPageTitle:
            "Datenannotations-Tool - KI-gestützte Datenlabeling-Plattform | Predsense",
          LabelingAppTitle: "Datenannotation & Labeling-Plattform",
          LabelingAppDescription:
            "Ein intuitives Datenannotations-Tool und KI-gestützte Datenlabeling-Plattform, die es Ihnen ermöglicht, Ihre Zeitreihendaten effizient zu annotieren, zu organisieren und zu analysieren. Unsere Datenannotationssoftware unterstützt automatisierte Annotation, KI-Annotations-Tools, Datensatzannotation und Machine-Learning-Annotations-Workflows. Perfekt für Zeitreihenannotation und Datennotation. Erstellen Sie Events, definieren Sie Regeln und nutzen Sie KI-gestützte Chat-Unterstützung, um Rohsensordaten in umsetzbare Erkenntnisse zu verwandeln.",

          // Labeling Features
          DataImport: "Datenimport",
          EventLabeling: "Event-Labeling",
          AutomatedLabeling: "Automatisiertes Labeling",
          AIAssistant: "KI-Assistent",
          Reporting: "Berichterstellung",
          DataExport: "Datenexport",

          LabelingUploadTitle: "Daten für Annotation hochladen",
          LabelingUploadDesc:
            "Laden Sie einfach Ihre CSV/Excel-Dateien mit Zeitreihen-Sensordaten in unser Datenannotations-Tool hoch. Unser Annotationstool validiert automatisch das Datenformat und bereitet es für Datenlabeling und Analyse vor. Perfekt für Zeitreihenannotation und Datennotations-Workflows als Teil der Machine-Learning-Datenvorbereitung.",

          LabelingCreateEventTitle: "Manuelle Datenannotation & Event-Labeling",
          LabelingCreateEventDesc:
            "Erstellen Sie manuell Events und annotieren Sie sie direkt über unser interaktives Diagramm. Wählen Sie einfach den Zeitbereich aus und definieren Sie Event-Eigenschaften. Perfekt für präzise Datenannotation spezifischer Vorfälle, Anomalien oder Betriebszustände in Ihren Produktionsdaten.",

          LabelingRulesTitle: "Automatisierte Datenannotation mit Regeln",
          LabelingRulesDesc:
            "Definieren Sie benutzerdefinierte Regeln für automatisierte Datenlabeling und Annotation. Unser KI-Annotationstool erkennt automatisch und erstellt Events basierend auf statischen Regeln. Legen Sie Schwellenwerte, Bedingungen und Trigger fest, die Ihren betrieblichen Anforderungen entsprechen. Einmal konfiguriert, können automatisierte Annotationsregeln sofort mehrere gelabelte Events in Ihrem gesamten Datensatz generieren. Perfekt für Datensatzannotation und Zeitreihenannotations-Automatisierung.",

          LabelingChatEventsTitle: "KI-unterstützte Event-Erkennung",
          LabelingChatEventsDesc:
            "Verwenden Sie unseren Chat, um in natürlicher Sprache zu beschreiben, wonach Sie suchen, und unser KI-Agent erkennt und markiert automatisch passende Events auf Ihren Charts. Unser KI-Agent übersetzt Text in Abfragen mit benutzerdefiniertem Code, um Muster zu identifizieren. Stellen Sie einfach Fragen wie 'Finde alle Temperaturspitzen über 80°C' und sehen Sie zu, wie der KI-Agent sie sofort identifiziert. Fortgeschrittene KI-Annotation für Zeitreihenannotations-Workflows.",

          LabelingChatAverageTitle: "Durchschnittswerte berechnen",
          LabelingChatAverageDesc:
            "Bitten Sie den KI-Assistenten, z.B. Durchschnittswerte für jeden Zeitraum und jede Spalte zu berechnen. Erhalten Sie sofort statistische Erkenntnisse ohne manuelle Berechnungen. Perfekt zum Vergleichen der Leistung über verschiedene Zeiträume oder zur Identifizierung von Basiswerten.",

          LabelingChatSimilarTitle: "Ähnliche Muster finden",
          LabelingChatSimilarDesc:
            "Entdecken Sie Korrelationen und ähnliche Muster zwischen verschiedenen Sensoren oder Datenströmen. Der KI-Assistent analysiert Beziehungen in Ihren Daten und hebt passende Muster hervor, um Verbindungen und Abhängigkeiten in Ihren Produktionsprozessen zu identifizieren.",

          LabelingChatYesterdayTitle: "Historische Daten vergleichen",
          LabelingChatYesterdayDesc:
            "Vergleichen Sie schnell aktuelle Daten mit gestrigen Werten oder einem beliebigen historischen Zeitraum. Der KI-Assistent überlagert historische Daten auf Ihren Charts und erleichtert es, Trends, Anomalien oder Änderungen in Ihren Produktionsmustern im Laufe der Zeit zu erkennen.",

          LabelingPdfReportTitle: "PDF-Berichte generieren",
          LabelingPdfReportDesc:
            "Exportieren Sie umfassende PDF-Berichte mit Ihren gelabelten Daten, Charts, Events mit Kontext. Berichte enthalten alle Annotationen, Regeln und Erkenntnisse in einem professionellen Format, bereit zum Teilen mit dem Management für schnelle datenbasierte Entscheidungen.",

          LabelingExportDataTitle:
            "Annotierte Daten für Machine Learning exportieren",
          LabelingExportDataDesc:
            "Exportieren Sie Ihren gelabelten Datensatz mit allen Events und Annotationen als CSV-Dateien. Die exportierten Daten enthalten ursprüngliche Sensorwerte plus zusätzliche Spalten für Event-Labels, Zeitstempel und Metadaten. Perfekt für das Training von Machine-Learning-Modellen oder weitere Analysen.",
          Collaboration: "Zusammenarbeit",
          StartFreeTrial: "Kostenlose Testversion starten",
          ViewPricing: "Preise ansehen",

          // Home Page SEO
          HomePageTitle:
            "KI-gestützte Analytikplattform für Zeitreihendaten | Predsense",
          HomePageDescription:
            "Transformieren Sie Ihre Betriebe mit No-Code-Analytik und KI-gestützten Erkenntnissen. Perfekt für Einzelpersonen, B2B-Teams, Enterprise-Lösungen und Organisationen, die datenbasierte Entscheidungen mit DSGVO-Konformität suchen.",
          HomePageKeywords:
            "Zeitreihenanalytik, Anomalieerkennung, Zeitreihendaten, Prognoseanalytik, No-Code-Analytik, B2B-Analytik, Fertigungsanalytik, Zeitreihenvisualisierung, KI-Analytik, Datenannotation, B2B-SaaS, Fertigungsunternehmen, Finanzanalytik, Vertriebsanalytik, DSGVO-Konformität, Automobilfertigung, OEM, API-Plattform, Datenschutz",

          // Pricing Page
          PricingPageTitle: "Preispläne - Zeitreihenanalytik | Predsense",
          PricingPageDescription:
            "Wählen Sie den richtigen Preisplan für Ihre Zeitreihenanalytik- und Anomalieerkennungsanforderungen. Flexible Pläne für Einzelpersonen, Teams und Unternehmen. Kostenlos starten oder auf Pro upgraden für erweiterte Funktionen.",
          PricingPageKeywords:
            "Preise, Zeitreihenanalytik Preise, Anomalieerkennung Preise, Analytik-Plattform Preise, B2B Preise, Enterprise Preise",
          Pricing: "Preise",
          PricingHeroDescription:
            "Wählen Sie den Plan, der zu Ihren Bedürfnissen passt. Beginnen Sie mit unserer kostenlosen Testversion oder wählen Sie einen Abonnementplan. Alle Pläne beinhalten Zugang zu unserer Zeitreihenanalytik- und Anomalieerkennungs-Plattform mit transparenter SaaS-Preisgestaltung.",
          TimeSeriesLabeling: "Zeitreihen-Labeling",
          Monthly: "Monatlich",
          Yearly: "Jährlich",
          Popular: "Beliebt",
          CurrentPlan: "Aktueller Plan",
          FreePlan: "Kostenlos",
          FreePrice: "0€",
          FreeDescription: "Grundlegende Funktionen mit begrenzter Nutzung",
          StarterPlan: "Starter",
          StarterPriceMonthly: "24€",
          StarterPriceYearly: "19€",
          StarterDescription: "Starter-Funktionen",
          ProPlan: "Pro",
          ProPriceMonthly: "79€",
          ProPriceYearly: "63€",
          ProDescription: "Erweiterte Funktionen mit höheren Limits",
          ProPlusPlan: "Pro Plus",
          ProPlusPriceMonthly: "249€",
          ProPlusPriceYearly: "199€",
          ProPlusDescription: "Premium-Funktionen mit maximalen Limits",
          EnterprisePlan: "Enterprise",
          EnterprisePrice: "Individuell",
          EnterpriseDescription: "Maßgeschneiderte Enterprise-Lösung",
          PricingFeature1: "10MB Datengröße pro Datensatz",
          PricingFeature2: "1 Datensatz",
          PricingFeature3: "1 Spalte",
          PricingFeature4: "30 Events",
          PricingFeature5: "100MB Datengröße pro Datensatz",
          PricingFeature6: "10 Datensätze",
          PricingFeature7: "10 Spalten",
          PricingFeature8: "1 Chat-Sitzung pro Datensatz",
          PricingFeature9: "50 Prompts pro Monat",
          PricingFeature10: "500 Events pro Datensatz",
          PricingFeature11: "Statische Regeln",
          PricingFeature12: "Bericht & Datensatz-Download",
          PricingFeature13: "250MB Datengröße pro Datensatz",
          PricingFeature14: "30 Datensätze",
          PricingFeature15: "50 Spalten",
          PricingFeature16: "3 Chat-Sitzungen pro Datensatz",
          PricingFeature17: "200 Prompts pro Monat",
          PricingFeature18: "1.500 Events pro Datensatz",
          PricingFeature19: "Prioritätssupport",
          PricingFeature20: "500MB Datengröße pro Datensatz",
          PricingFeature21: "50 Datensätze",
          PricingFeature22: "100 Spalten",
          PricingFeature23: "5 Chat-Sitzungen pro Datensatz",
          PricingFeature24: "500 Prompts pro Monat",
          PricingFeature25: "3.000 Events pro Datensatz",
          PricingFeature26: "24/7 Prioritätssupport",
          PricingFeature27: "Benutzerdefinierte Datengröße pro Datensatz",
          PricingFeature28: "Unbegrenzte Datensätze",
          PricingFeature29: "Unbegrenzte Spalten",
          PricingFeature30: "Unbegrenzte Chat-Sitzungen",
          PricingFeature31: "Unbegrenzte Prompts",
          PricingFeature32: "Unbegrenzte Events",
          PricingFeature33: "Echtzeit-Streaming",
          PricingFeature34: "SLA & dedizierter Support",
          PricingFAQTitle: "Häufig gestellte Fragen",
          PricingFaq1Question: "Kann ich meinen Plan später ändern?",
          PricingFaq1Answer:
            "Ja, Sie können Ihren Plan jederzeit upgraden oder downgraden. Änderungen werden in Ihrem nächsten Abrechnungszyklus wirksam.",
          PricingFaq2Question: "Welche Zahlungsmethoden akzeptieren Sie?",
          PricingFaq2Answer:
            "Wir akzeptieren alle gängigen Kreditkarten und können für Enterprise-Kunden Rechnungsabrechnung arrangieren.",
          PricingFaq3Question: "Gibt es eine kostenlose Testversion?",
          PricingFaq3Answer:
            "Ja, unser kostenloser Plan ist unbegrenzt verfügbar. Sie können auch eine 14-tägige kostenlose Testversion eines kostenpflichtigen Plans starten.",
          PricingFaq4Question: "Bieten Sie Rabatte für Jahrespläne an?",
          PricingFaq4Answer:
            "Ja, Jahrespläne beinhalten einen Rabatt, der 2 Monaten kostenlos im Vergleich zur monatlichen Abrechnung entspricht.",

          // Services Page
          ServicesPageTitle:
            "KI-Management-Beratung & AI Consulting Services | Predsense",
          ServicesPageDescription:
            "AI Consulting und KI-Management-Beratung für Datenintegration, Projektmanagement mit KI, maßgeschneiderte Enterprise-IT und Geschäftsprozessautomatisierung. KI-Workshops und Artificial-Intelligence-Workshops für Führungskräfte. KI für Risikomanagement. Transformieren Sie Ihre Betriebe mit unseren professionellen Dienstleistungen.",
          ServicesPageKeywords:
            "AI management consulting, KI-Management-Beratung, AI consulting, project management AI, KI-Projektmanagement, AI workshops, AI for managers, artificial intelligence workshops, AI for risk management, KI Risikomanagement, Datenintegrationsdienstleistungen, IT-Beratung, Enterprise-IT-Lösungen, Projektmanagement, Geschäftsprozessautomatisierung, Analytikdienstleistungen, B2B-Dienstleistungen, Tech-Beratung, Technologieberatung, Beratungsdienstleistungen, Projektmanagement-Beratung, Datenintegration, SQL-Integration, Geschäftsprozess-Mapping, Workflow-Automatisierung",
          ServicesHeroTitle: "AI Consulting & Professionelle Dienstleistungen",
          ServicesHeroSubtitle:
            "KI-Management-Beratung und AI Consulting für Betrieb und Strategie. Wir bieten Project Management AI, Artificial-Intelligence-Workshops und AI-Workshops für Führungskräfte. Expertenunterstützung in Datenintegration, Analytik und KI für Risikomanagement.",
          WhoWeServe: "Wen wir bedienen",
          WhoWeServeDesc:
            "Unsere AI-Consulting- und KI-Management-Beratungsdienstleistungen richten sich an Operations-Manager, Ingenieure und Datenanalysten. Wir bieten AI for Managers, Artificial-Intelligence-Workshops und Project Management AI zur Prozessverbesserung.",
          OperationsManagers: "Operations-Manager",
          Engineers: "Ingenieure",
          DataAnalysts: "Datenanalysten",
          OurOfferings: "Unsere Angebote",
          OurOfferingsDesc:
            "Umfassendes AI Consulting, Project Management AI und Artificial-Intelligence-Workshops für datengetriebene Betriebsabläufe und AI for Risk Management.",
          Service1DataIntegration: "Datenintegration",
          Service1DataIntegrationDesc:
            "Verbinden Sie verschiedene bestehende Systeme zu einem einheitlichen Data Lake durch umfassende Datenintegrationsdienste. Perfekt für Betriebsdaten, Kundendatenintegration und SQL-Integrations-Workflows.",
          Service1DataIntegrationProblem:
            "Getrennte Datenquellen und manuelle Datenübertragungen",
          Service1DataIntegrationSolution:
            "Automatisierte Datenpipelines und Echtzeit-Synchronisierung",
          Service2CustomEnterpriseIT: "Maßgeschneiderte Enterprise-IT-Lösungen",
          Service2CustomEnterpriseITDesc:
            "Maßgeschneiderte Enterprise-IT-Lösungen und benutzerdefinierte IT-Lösungen, die auf Ihre spezifischen Geschäftsanforderungen zugeschnitten sind. Mit unserer industriellen KI-Erfahrung helfen wir Ihnen, den richtigen Technologie-Stack zu identifizieren und zu implementieren.",
          Service2CustomEnterpriseITProblem:
            "Standardlösungen passen nicht zu Ihren einzigartigen Anforderungen",
          Service2CustomEnterpriseITSolution:
            "Maßgeschneiderte Lösungen, die auf Ihre Geschäftsprozesse abgestimmt sind",
          Service3Consulting: "AI Consulting & KI-Management-Beratung",
          Service3ConsultingDesc:
            "AI Consulting und KI-Management-Beratung zur Optimierung Ihrer Analytik- und Datenstrategie. Wir bieten AI-Workshops und Artificial-Intelligence-Workshops für Führungskräfte und Teams. Expertenberatung für B2B-Entscheider mit Fokus auf AI for Managers.",
          Service3ConsultingProblem:
            "Unsicherheit darüber, wie man KI und Datenanalytik effektiv nutzt",
          Service3ConsultingSolution:
            "Strategisches AI Consulting und KI-Management-Beratung zur Maximierung Ihrer Daten- und KI-Investitionen",
          Service4ProjectManagement: "Project Management AI & Prozessverbesserung",
          Service4ProjectManagementDesc:
            "Project Management AI und bewährte Methoden zur Optimierung Ihrer Betriebe. Wir unterstützen AI for Risk Management und strukturierte Umsetzung, damit Ihre Initiativen im Plan bleiben.",
          Service4ProjectManagementProblem:
            "Ineffiziente Prozesse, Mangel an Projektstruktur und unkontrollierte Risiken",
          Service4ProjectManagementSolution:
            "Strukturiertes Project Management AI, Prozessoptimierung und AI for Risk Management",
          Service5BusinessProcessAutomation: "Geschäftsprozessautomatisierung",
          Service5BusinessProcessAutomationDesc:
            "Automatisieren Sie repetitive Aufgaben und Workflows zur Effizienzsteigerung",
          Service5BusinessProcessAutomationProblem:
            "Manuelle, zeitaufwändige Prozesse, die die Produktivität reduzieren",
          Service5BusinessProcessAutomationSolution:
            "Automatisierte Workflows, die Zeit sparen und Fehler reduzieren",
          Service6AnalyticsServices: "Analytikdienstleistungen",
          Service6AnalyticsServicesDesc:
            "Erweiterte Analytik und Berichterstellung für datengetriebene Entscheidungen",
          Service6AnalyticsServicesProblem:
            "Mangel an Erkenntnissen aus Ihren Betriebsdaten",
          Service6AnalyticsServicesSolution:
            "Umfassende Analytik und umsetzbare Erkenntnisse",
          Problem: "Problem",
          Solution: "Lösung",
          ReadyToGetStarted: "Bereit zum Starten?",
          ServicesCTADescription:
            "Kontaktieren Sie uns, um Ihre spezifischen Bedürfnisse zu besprechen und eine maßgeschneiderte Lösung zu erhalten",
          ServicesBookFreeConsultation: "Gratis Ersttermin buchen",

          // About Page
          AboutPageTitle: "Über uns - Zeitreihenanalytik-Experten | Predsense",
          AboutPageDescription:
            "Erfahren Sie mehr über Predsense, unsere Mission zur Demokratisierung von KI für Unternehmen in verschiedenen Branchen und unser Team von Experten in Zeitreihenanalytik, Anomalieerkennung und Datenannotation. Wir helfen B2B-Teams, Fertigungsunternehmen, Finanzanalysten und Enterprise-Organisationen, Betriebe mit No-Code-Analytik zu transformieren.",
          AboutPageKeywords:
            "über Predsense, Zeitreihenanalytik-Unternehmen, Anomalieerkennungsexperten, Fertigungs-KI, B2B-Analytik-Team, Datenannotationsexperten, No-Code-Analytik, Enterprise-Analytik, Finanzanalytik, Vertriebsanalytik",
          AboutHeroTitle: "Über Predsense",
          AboutHeroSubtitle:
            "Demokratisierung von KI für Unternehmen und Betriebe durch innovative Zeitreihenanalytik. Unsere No-Code-Plattform hilft Einzelpersonen, B2B-Teams, Fertigungsunternehmen, Finanzanalysten, Vertriebsteams und Enterprise-Organisationen, Daten in umsetzbare Erkenntnisse mit DSGVO-Konformität zu transformieren.",
          ProblemWeSolve: "Das Problem, das wir lösen",
          ProblemWeSolveDesc:
            "Unternehmen und Betriebsteams in verschiedenen Branchen stehen vor einzigartigen Herausforderungen bei der Analyse von Zeitreihendaten. Ob in der Fertigung, im Finanzwesen, im Vertrieb oder in anderen B2B-Betrieben - die Extraktion aussagekräftiger Erkenntnisse aus komplexen Daten erfordert spezialisierte Tools und Expertise.",
          ComplexTimeSeries: "Komplexe Zeitreihendaten",
          ComplexTimeSeriesDesc:
            "Unternehmen generieren große Mengen an Zeitreihendaten aus Sensoren, Betriebssystemen, Finanzsystemen und Vertriebsprozessen, die ohne spezialisierte Analytiktools und KI-gestützte Erkenntnisse schwer zu analysieren sind.",
          ProcessOptimization: "Prozessoptimierung",
          ProcessOptimizationDesc:
            "Die Identifizierung von Ineffizienzen und Optimierungsmöglichkeiten in Fertigung, Finanzen, Vertrieb und Betrieb erfordert tiefe Datenanalyseexpertise und erweiterte Analytikfähigkeiten, die vielen Teams fehlen.",
          AnomalyDetectionChallenge: "Anomalieerkennungs-Herausforderung",
          AnomalyDetectionChallengeDesc:
            "Die Erkennung von Anomalien in Zeitreihen ist zeitaufwändig und muss skalierbar sein, um Wirkung zu erzielen. Unsere KI-gestützte Analytik-Plattform speichert Erkenntnisse Ihrer Experten und die Wissensbasis wird verwendet, um automatisch Probleme in Prozessen branchenübergreifend (Produktion, Finanzen, Vertrieb und Betriebsdaten) zu identifizieren.",
          HowWeSolveIt: "Wie wir es lösen",
          HowWeSolveItDesc:
            "Unsere No-Code-Plattform kombiniert Benutzerfreundlichkeit mit leistungsstarker KI-gestützter Analytik und macht erweiterte Zeitreihenanalyse für B2B-Teams, Fertigungsexperten, Finanzanalysten und Betriebsmanager ohne Datenwissenschaftsexpertise zugänglich.",
          NoCodeLabelingPlatform: "No-Code-Labeling-Plattform",
          NoCodeLabelingPlatformDesc:
            "Eine intuitive Datenannotationsplattform zur Annotation und Analyse von Zeitreihendaten ohne Programmierung. Perfekt für Datensatzannotation, Datennotation und Vorbereitung gelabelter Datensätze für Machine-Learning-Workflows in verschiedenen Branchen.",
          B2BAnomalyDetection: "B2B-Anomalieerkennung",
          B2BAnomalyDetectionDesc:
            "Enterprise-Anomalieerkennung, angetrieben von fortschrittlichen KI-Algorithmen und API-Plattform-Integration. Erstellt mit FastAPI, bietet unsere Lösung nahtlosen API-Gateway-Zugang für B2B-Teams und Enterprise-Organisationen.",
          LearnMore: "Mehr erfahren",
          LearnMoreAboutOurProducts: "Mehr über unsere Produkte erfahren",
          AboutCTADescription:
            "Erkunden Sie unsere Produkte und sehen Sie, wie sie Ihre Betriebe transformieren können",
          ExploreProducts: "Produkte erkunden",
          Engineer: "Ingenieur",
          "Project Manager": "Projektmanager",
          "AI/ML": "KI/ML",
          "Domain Knowledge": "Domänenwissen",

          // Home Page Hero Section
          HeroTitle: "KI-gestützte Analytikplattform für Zeitreihendaten",
          HeroSubtitle:
            "Transformieren Sie Ihre Betriebe mit No-Code-Analytik und KI-gestützten Erkenntnissen. Perfekt für Einzelpersonen, B2B-Teams, Enterprise-Lösungen und Organisationen, die datenbasierte Entscheidungen mit DSGVO-Konformität suchen.",
          MadeFor: "Gemacht für",

          // Home Page Additional Translations
          ExploreOurSolutions: "Unsere Lösungen erkunden",
          B2CAndB2B: "B2C & B2B",
          TimeSeriesLabelingDescription:
            "Ein intuitives Datenannotations-Tool für Zeitreihendaten. Perfekt für die Vorbereitung gelabelter Datensätze für Machine-Learning-Workflows und die Quantifizierung von Anwendungsfällen innerhalb von Minuten.",
          CSVImportExport: "CSV Import & Export",
          EventAnnotation: "Event-Annotation",
          ExploreProduct: "Produkt erkunden",
          B2BOnly: "Nur B2B",
          AnomalyDetection: "Anomalieerkennung",
          AnomalyDetectionDescription:
            "Enterprise-Anomalieerkennung, angetrieben von KI für Zeitreihendaten. Erstellt für Ingenieure und Domänenexperten ohne Programmierkenntnisse, um Prognoseanalytik im großen Maßstab zu implementieren. Das Tool kann über APIs als Add-on zu bestehenden Enterprise-Lösungen integriert werden.",
          AutomatedAnomalyDetection: "Automatisierte Anomalieerkennung",
          TestimonialsOverline: "Referenzen",
          TestimonialsTitle: "Das sagen unsere Kunden",
          TestimonialsSubtitle:
            "Rückmeldungen von Organisationen nach der Erkundung unserer Plattform.",
          HomeTestimonial1Quote:
            "Unser Team empfand die Demo von Predsense als aufschlussreich: ein klares und intuitives System zur Erkennung und Interpretation von Anomalien in Datensätzen. Die Übersichtlichkeit und Benutzerfreundlichkeit der Plattform eignet sie gut für datengestützte Wartungsentscheidungen.",
          HomeTestimonial1Author: "Research institute, Canada",
          FrequentlyAskedQuestions: "Häufig gestellte Fragen",
          FAQSubtitle:
            "Finden Sie Antworten auf häufige Fragen zu unserer Plattform",
          AboutUs: "Über Uns",
          "Cookie Policy": "Cookie-Richtlinie",

          // Blog
          Blog: "Blog",
          BlogPageTitle: "Blog | Predsense – Einblicke zu Zeitreihen & Analytik",
          BlogPageDescription:
            "Aktuelle Beiträge zu Zeitreihenanalytik, Anomalieerkennung und No-Code-Datentools für Fertigung und Betrieb.",
          BlogHeroTitle: "Blog",
          BlogHeroSubtitle:
            "Gedanken zu Daten, Analytik und der Zukunft der Arbeit – vom Team, das sie baut.",
          BackToBlog: "Zurück zum Blog",
          BlogNotFound: "Beitrag nicht gefunden",
          Latest: "Aktuell",

          // Home FAQ
          HomeFaq1Question: "Was ist Zeitreihenanalytik?",
          HomeFaq1Answer:
            "Zeitreihenanalytik ist die Analyse von Datenpunkten, die über die Zeit gesammelt wurden, um Muster, Trends und Anomalien zu identifizieren. Unsere Tools helfen Ihnen, Zeitreihendaten von Sensoren, Maschinen und Betriebssystemen in Minuten statt Monaten zu analysieren.",
          HomeFaq2Question: "Wie funktioniert Anomalieerkennung?",
          HomeFaq2Answer:
            "Unsere KI-gestützte Anomalieerkennung identifiziert automatisch ungewöhnliche Muster in Ihren Zeitreihendaten. Sie verwendet Machine-Learning-Algorithmen, um normales Verhalten zu lernen und Abweichungen zu markieren, die auf Probleme hinweisen könnten.",
          HomeFaq3Question:
            "Benötige ich Programmierkenntnisse, um die Plattform zu nutzen?",
          HomeFaq3Answer:
            "Nein, unsere Plattform ist als No-Code-Lösung konzipiert. Sie können Ihre Daten hochladen, Annotationen erstellen und Ergebnisse analysieren, ohne Programmierkenntnisse zu benötigen.",
          HomeFaq4Question: "Welche Datenformate unterstützen Sie?",
          HomeFaq4Answer:
            "Wir unterstützen CSV- und Excel-Dateien mit Zeitreihendaten für einen schnellen Start. Dateien müssen mindestens eine Zeitstempel-Spalte und eine numerische Spalte enthalten. Für Unternehmen kann das Tool auch als Add-on über APIs in Ihren bestehenden Tech-Stack integriert werden. Die Plattform validiert und verarbeitet Ihr Datenformat automatisch beim Upload.",
          HomeFaq5Question: "Ist meine Daten sicher und DSGVO-konform?",
          HomeFaq5Answer:
            "Ja, wir nehmen Datensicherheit ernst. Unsere Plattform ist DSGVO-konform mit Enterprise-Datenschutz und Verschlüsselung, um Ihre sensiblen Informationen zu schützen.",

          // Anomaly Detection Page
          AnomalyDetectionPageTitle:
            "Anomalieerkennung - API-Plattform für Zeitreihen-Anomalieerkennung | Predsense",
          AnomalyDetectionPageDescription:
            "Enterprise-Anomalieerkennung für Zeitreihendaten mit umfassender API-Integration. KI-gestützte Plattform, die mit FastAPI erstellt wurde und automatisch Anomalien erkennt, Ausfälle vorhersagt und umsetzbare Erkenntnisse für B2B-Betriebe liefert. Perfekt für API-Entwickler, API-Management und Enterprise-Teams, die API-Gateway-Integration benötigen.",
          AnomalyDetectionPageKeywords:
            "Anomalieerkennung, Zeitreihen-Anomalieerkennung, KI-Anomalieerkennung, automatisierte Anomalieerkennung, B2B-Anomalieerkennung, prädiktive Wartung, Zeitreihenanalytik, API-Plattform, API-Gateway, FastAPI, REST-API, API-Integration, API-Management",
          ThresholdEventLabeling: "Schwellenwert-Event-Labeling",
          SelfServiceEnterprise: "Self-Service Enterprise",
          LoginToApp: "Zur App anmelden",
          ContactForB2B: "Kontakt für B2B",

          // SEO Optimized Content - German
          HeroSEOText:
            "Transformieren Sie Ihre Fertigungsbetriebe mit unserer B2B-SaaS-Plattform. Unsere No-Code-Analytiklösung hilft Fertigungsunternehmen, den Vertrieb zu optimieren, Finanzanalysen zu verbessern und DSGVO-Konformität sicherzustellen. Perfekt für Automobilfertigung, OEM-Betriebe und Enterprise-Teams, die datenbasierte Erkenntnisse suchen.",
          ProductsShowcaseSEO:
            "Entdecken Sie unsere umfassenden Lösungen für Zeitreihenanalytik, Datenannotation und Anomalieerkennung. Unsere Plattform unterstützt B2B- und B2C-Benutzer mit erweiterter API-Integration und ermöglicht nahtlose Datenanalyse für Fertigungs-, Finanz- und Vertriebsteams.",
          PartnersSEOText:
            "Wir arbeiten mit führenden Technologieanbietern und Innovationszentren zusammen, um Enterprise-Analytiklösungen zu liefern. Unsere Partnerschaften ermöglichen nahtlose Integration mit bestehenden B2B-Systemen und gewährleisten DSGVO-Konformität und Datenschutz für Fertigungs- und Finanzanalysen.",
          FAQSEOHeading:
            "Häufig gestellte Fragen zu B2B-Analytik und Fertigungslösungen",
          FAQSEOText:
            "Erfahren Sie mehr über unsere No-Code-Analytikplattform, Datenannotationstools, API-Integration und wie unsere Lösungen Fertigungsunternehmen, B2B-Teams und Enterprise-Organisationen helfen, Betriebe zu optimieren, Vertriebsanalysen zu verbessern und DSGVO-Konformität sicherzustellen. Unsere Plattform unterstützt Automobilfertigung, OEM-Betriebe, Finanzanalysen und mehr.",
          TimeSeriesLabelingSEO:
            "Unsere Datenannotationsplattform unterstützt Datensatzannotation, Datennotation und Machine-Learning-Workflows. Perfekt für Zeitreihenannotation, automatisiertes Labeling und Vorbereitung von Daten für KI-Modelle. Ideal für B2B- und B2C-Benutzer, die effiziente Datenannotationstools suchen.",
          AnomalyDetectionSEO:
            "Erweiterte API-Plattform für Zeitreihen-Anomalieerkennung. Unsere Anomalieerkennungssoftware integriert sich nahtlos über API-Gateway und unterstützt FastAPI- und REST-API-Architekturen. Perfekt für B2B-Enterprise-Lösungen, die Echtzeit-Anomalieerkennung und Prognoseanalytik erfordern.",
          AnomalyDetectionSEOHeading:
            "Enterprise-API-Plattform für Zeitreihen-Anomalieerkennung",
          AnomalyDetectionSEOText:
            "Unsere API-Plattform bietet umfassende Anomalieerkennungsfunktionen über REST-API und API-Gateway-Integration. Erstellt mit FastAPI für optimale Leistung, ermöglicht unsere API-Lösung nahtlose Integration mit bestehenden Systemen. Perfekt für Entwickler, API-Entwickler und B2B-Teams, die robustes API-Management und Anomalieerkennungs-APIs benötigen. Unterstützung für Echtzeit-Streaming, Batch-Verarbeitung und benutzerdefinierte API-Endpunkte macht unsere Plattform ideal für Enterprise-Bereitstellungen.",
          LabelingSEOHeading:
            "Erweiterte Datenannotations- und Datensatz-Labeling-Plattform",
          LabelingSEOText:
            "Unsere Datenannotationsplattform bietet umfassende Tools für Datensatzannotation, Datennotation und Zeitreihenannotation. Ob Sie KI-Annotationstools, automatisiertes Datenlabeling oder manuelle Annotation-Workflows benötigen, unsere Plattform unterstützt alle Datenannotations-Anwendungsfälle. Perfekt für Machine-Learning-Datenvorbereitung, KI-Modelltraining und Erstellung hochwertiger gelabelter Datensätze. Unterstützung für CSV-Import/Export, kollaborative Annotation und KI-unterstütztes Labeling macht unsere Plattform ideal für B2B- und B2C-Benutzer.",
          ServicesSEOHeading:
            "KI-Management-Beratung, AI Consulting & Datenintegrationsdienste",
          ServicesSEOText:
            "Unsere umfassenden Dienstleistungen umfassen AI Consulting, KI-Management-Beratung, Project Management AI und Datenintegration. Wir bieten AI-Workshops, Artificial-Intelligence-Workshops und AI-for-Managers-Programme sowie AI for Risk Management. Wir spezialisieren uns auf Kunden-Onboarding, SQL-Integration, Geschäftsprozess-Mapping und Workflow-Automatisierung. Perfekt für B2B-Teams und Unternehmen, die Experten-AI-Consulting, Tech-Beratung und maßgeschneiderte IT-Lösungen suchen. Unser Team bietet Technologieberatung, Projektmanagement-Beratung und Geschäftsprozess-Automatisierung zur Optimierung Ihrer Betriebe.",
          PricingSEOHeading: "Flexible Preispläne für Zeitreihenanalytik",
          PricingSEOText:
            "Wählen Sie aus unseren flexiblen Preisplänen, die für B2B-Teams, Enterprise-Organisationen und Einzelbenutzer entwickelt wurden. Beginnen Sie mit einer kostenlosen Testversion, um unsere Zeitreihenanalytik- und Anomalieerkennungsplattform zu erkunden. Unsere SaaS-Preisgestaltung umfasst monatliche und jährliche Abonnementoptionen mit transparenter Preisgestaltung für alle Pläne. Perfekt für Fertigungsunternehmen, B2B-Betriebe und Enterprise-Teams, die kosteneffektive Analytiklösungen suchen.",
        },
      },
    },
  });

export default i18n;
